import { UpgradePlan, UpgradeStage } from 'api/models';

export const UPGRADE_PLAN_ADDONS_CERT_MANAGER: UpgradePlan = {
  id: 'upgr_ea53db65-3d8d-4744-b8b7-92e3c7552932',
  name: 'plan-cert-manager-v1.16.0-to-v1.19.1',
  resources: {
    addon_instances: [
      {
        id: 'addinst_cert-manager-3',
      },
    ],
  },
  created: new Date(2025, 7, 16).getTime(),
  deployment_strategy: 'in-place',
  status: 'in-progress',
  owner: {
    email: 'roger@chkk.io',
    id: 'usr_w12123',
    name: 'Roger Walter',
    picture: '',
  },
  current_version: '1.16.0',
  desired_version: '1.19.1',
  requested_by: {
    email: 'roger@chkk.io',
    id: 'usr_w12123',
    name: 'Roger Walter',
    picture: '',
  },
  header: {
    items: [
      {
        title: 'Project',
        value: 'cert-manager',
      },
      {
        title: 'Version',
        value: '1.16.0',
      },
      {
        title: 'Recommended',
        value: '1.19.1',
      },
      {
        title: 'Blueprint',
        value: 'In-Place',
      },
      {
        title: 'Target K8s Version',
        value: '1.32',
      },
    ],
  },
};

export const UPGRADE_PLAN_ADDONS_CERT_MANAGER_STAGES: UpgradeStage[] = [
  {
    allowed_action_types: [],
    created: 0,
    name: 'Change Summary',
    stage_number: 1,
    status: 'in-progress',
    steps: [
      {
        step_number: 1,
        comments: {},
        name: 'Compatibility & Recommendations Summary',
        owner: 'chkk',
        status: 'in-progress',
        allowed_action_types: [],
        content_blocks: [
          {
            style: 'markdown',
            text: '\n',
            type: 'text',
          },
          {
            column_definitions: [
              {
                title: 'Name',
              },
              {
                title: 'Namespaces',
              },
              {
                title: 'Current',
              },
              {
                title: 'Upgrade',
              },
              {
                info_text:
                  'Suggested versions do not go through Pre-verification. Request an Upgrade Templates for Pre-verified Version Recommendations. Learn more: https://docs.chkk.io/features/upgrade-preverification#upgrade-preverification',
                title: 'Suggested',
              },
              {
                info_text:
                  'Will the current remain compatible with the next Kubernetes version after the cluster is upgraded?',
                title: 'K8s Compatibility',
              },
              {
                info_text:
                  'Is the current version supported by its upstream community, cloud or vendor?',
                title: 'Supported',
              },
              {
                info_text: 'Is the current version younger than 2 years?',
                title: 'Age < 2yr',
              },
              {
                info_text:
                  'Use the feedback buttons to indicate whether you agree or disagree with this suggestion.',
                title: 'Give Feedback',
              },
            ],
            data: [
              [
                {
                  value: 'cert-manager',
                },
                {
                  value: 'cert-manager',
                },
                {
                  value: '1.16.0',
                },
                {
                  badges: [
                    {
                      text: 'Required',
                      variant: 'warning',
                    },
                  ],
                  value: '',
                },
                {
                  value: '1.19.1',
                },
                {
                  icon: {
                    tooltip:
                      'Version 1.16.0 is not listed as compatible with Kubernetes 1.33.',
                    variant: 'error',
                  },
                  value: '',
                },
                {
                  icon: {
                    tooltip:
                      'Version 1.16.0 is no longer within cert-manager’s supported release window.',
                    variant: 'error',
                  },
                  value: '',
                },
                {
                  icon: {
                    variant: 'success',
                  },
                  value: '',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
            ],
            type: 'table',
          },
          {
            style: 'markdown',
            text: '\n',
            type: 'text',
          },
        ],
        created: 0,
        updated: 0,
      },
      {
        step_number: 2,
        comments: {},
        name: 'Component Changes',
        owner: 'chkk',
        status: 'in-progress',
        allowed_action_types: [],
        content_blocks: [
          {
            column_definitions: [
              {
                title: 'Add-on Component',
              },
              {
                title: 'Resource Name',
              },
              {
                title: 'Current Version',
              },
              {
                title: 'Recommended Version',
              },
            ],
            data: [
              [
                {
                  value: 'cainjector',
                },
                {
                  value: 'cert-manager-cainjector',
                },
                {
                  value: '1.16.0',
                },
                {
                  value: '1.19.1',
                },
              ],
              [
                {
                  value: 'controller',
                },
                {
                  value: 'cert-manager',
                },
                {
                  value: '1.16.0',
                },
                {
                  value: '1.19.1',
                },
              ],
              [
                {
                  value: 'webhook',
                },
                {
                  value: 'cert-manager-webhook',
                },
                {
                  value: '1.16.0',
                },
                {
                  value: '1.19.1',
                },
              ],
            ],
            type: 'table',
          },
          {
            style: 'markdown',
            text: '\n',
            type: 'text',
          },
        ],
        created: 0,
        updated: 0,
      },
      {
        step_number: 3,
        comments: {},
        name: 'Breaking Changes & Upgrade Considerations',
        owner: 'chkk',
        status: 'in-progress',
        allowed_action_types: [],
        content_blocks: [
          {
            style: 'markdown',
            text: '\n## 1.19\n\n- The `ACMEHTTP01IngressPathTypeExact` feature gate remains at Beta status with `default: true` in v1.19.0 (first introduced as Beta in v1.18.1). This changes the Ingress `pathType` for ACME HTTP-01 challenge solvers from `ImplementationSpecific` to `Exact`. The change ensures challenge paths are interpreted literally rather than as patterns or regular expressions. ACME HTTP-01 challenges may fail with ingress-nginx controllers that do not properly support `pathType: Exact` (older versions). Existing challenge solvers will use `Exact` path matching, which may not work with all Ingress controller implementations. Users with custom Ingress configurations expecting `ImplementationSpecific` behavior may see challenge validation failures. Standards-compliant Ingress controllers (e.g., Cilium) will benefit from improved security and correctness. If using an older or non-compliant ingress-nginx version that fails HTTP-01 challenges, disable the feature gate: `--feature-gates=ACMEHTTP01IngressPathTypeExact=false`. In Helm deployments, set `featureGates: "ACMEHTTP01IngressPathTypeExact=false"` in values. Test ACME HTTP-01 challenges after upgrading to ensure Ingress controller compatibility. Consider upgrading Ingress controllers to versions that properly support `pathType: Exact` (Kubernetes 1.19+). For standards-compliant Ingress controllers, no action is required as `Exact` is the correct pathType for ACME challenges. \n- The `certmanager_acme_client_request_count` and `certmanager_acme_client_request_duration_seconds` Prometheus metrics had their high-cardinality `path` label removed and replaced with a bounded-cardinality `action` label. The new label structure is: `scheme`, `host`, `action`, `method`, `status`. Existing Prometheus queries, dashboards, and alerting rules that reference the `path` label on ACME client metrics will break. Metrics scraped before upgrade will have `path` label, while post-upgrade metrics will have `action` label, causing series mismatches. Grafana dashboards filtering or grouping by `path` label will show no data after upgrade. Alerts based on specific path values will stop firing. Update all Prometheus queries to use `action` label instead of `path` label. Modify Grafana dashboards that display `certmanager_acme_client_request_count` or `certmanager_acme_client_request_duration_seconds` metrics. Revise alerting rules (Prometheus, AlertManager) that filter by `path` label to use `action` instead. Review and update any custom monitoring tools or scripts that consume these metrics. The `action` label values are logical ACME operations (e.g., "new_account", "new_order", "finalize_order") rather than HTTP paths. \n- The `CAInjectorMerging` feature gate was promoted from Alpha to Beta and is now enabled by default in v1.19.0. This changes the CA Injector\'s behavior from replacing CA certificates outright to merging new CA certificates with existing ones in target resources (ConfigMaps, ValidatingWebhookConfigurations, MutatingWebhookConfigurations, APIServices, CustomResourceDefinitions). Existing deployments will experience a behavior change where CA data is merged instead of replaced when the cainjector updates target resources. If multiple Certificate resources inject CA data into the same target, all CA certificates will be accumulated instead of the last one overwriting previous ones. This may result in larger CA bundles containing certificates from multiple sources. Downstream consumers expecting only a single CA certificate may need adjustments. To restore the previous replace behavior, disable the feature gate by setting `--feature-gates=CAInjectorMerging=false` on the cainjector component. Alternatively, set `featureGates: "CAInjectorMerging=false"` in Helm values under the cainjector configuration. Review injected CA bundles to ensure the merged behavior is acceptable for your use case. \n- In v1.19.0, CRD-based API defaults were introduced for `Certificate.Spec.IssuerRef` and `CertificateRequest.Spec.IssuerRef` fields, automatically setting `kind: Issuer` and `group: cert-manager.io` when omitted. This was reverted in v1.19.1 due to unexpected certificate renewals. The defaults were applied by `SetObjectDefaults_Certificate` and `SetObjectDefaults_CertificateRequest` functions in the CRD conversion logic. **v1.19.0 only**: Upgrading to v1.19.0 triggers unexpected certificate renewals for any Certificate resources where `issuerRef.kind` or `issuerRef.group` was omitted. Certificate re-issuance occurs even when the issuer configuration has not changed. Increased API server load and ACME rate limit consumption due to unnecessary renewals. Potential service disruption if certificates are renewed during critical operations. **v1.19.1+**: The issue is resolved by reverting the API defaults. **If on v1.19.0**: Upgrade immediately to v1.19.1 or later to avoid continued unexpected renewals. **If affected by renewals**: No manual intervention required after upgrading to v1.19.1; certificates will stabilize. Review certificate renewal logs from v1.19.0 period to identify any that were unnecessarily renewed. Check ACME provider rate limit consumption if using Let\'s Encrypt or similar providers. Monitor for any certificates that may have been in a renewal loop during v1.19.0 deployment. \n\n\n## 1.18\n\n- Changed the Kubernetes Ingress `pathType` from `ImplementationSpecific` to `Exact` to ensure reliable ingress controller behavior and enhanced security. \n- cert-manager no longer publishes packages to RedHat OpenShift OperatorHub or operatorhub.io as of v1.18.0. The last available version on OperatorHub is v1.16.5. Users relying on OperatorHub for installation cannot install or upgrade to cert-manager v1.18.x or later. Existing OperatorHub-based deployments on v1.16.5 or earlier cannot upgrade via OperatorHub. No future security patches or bug fixes will be available through OperatorHub channels. Migrate from OperatorHub installation to supported installation methods (Helm charts, kubectl apply with manifests, or other supported methods). Plan migration strategy before cert-manager v1.16.x reaches end of support. Review cert-manager documentation for alternative installation methods at https://cert-manager.io/docs/installation/. [[1](https://cert-manager.io/docs/installation/)]\n- The PathType for ACME HTTP01 Ingress-based challenges changed from `ImplementationSpecific` to `Exact` in v1.18.0. This is controlled by the feature gate `ACMEHTTP01IngressPathTypeExact` (beta, default. enabled in v1.18.0, added in v1.18.1). ACME HTTP01 challenges fail on ingress-nginx >= v1.12.0 with default configuration due to buggy `strict-validate-path-type` validation that rejects dots in paths with `PathType. Exact`. Error message. `admission webhook validate.nginx.ingress.kubernetes.io denied the request. ingress contains invalid paths. path /.well-known/acme-challenge/<TOKEN> cannot be used with pathType Exact`. Certificate issuance/renewal via HTTP01 challenges stops working for affected configurations. Choose one of the following options if using ingress-nginx >= v1.12.0. Option 1. Disable the feature gate in cert-manager (Helm values). Option 2. Disable strict path validation in ingress-nginx (Helm values). \n- Set the default revisionHistoryLimit to 1 for CertificateRequest revisions to reduce resource usage; this may affect backwards compatibility. \n- The default value of `Certificate.Spec.RevisionHistoryLimit` changed from `nil` (unlimited) to `1` in v1.18.0. This default is applied in the revision manager controller when the field is unset. Old CertificateRequest resources are automatically garbage collected, keeping only the most recent revision. Upon upgrade to v1.18.x, all stale CertificateRequests (older than the most recent) are deleted for Certificates without explicit `revisionHistoryLimit` set. Users relying on historical CertificateRequest resources for audit, debugging, or rollback lose access to those resources. CertificateRequest retention for compliance or troubleshooting purposes is reduced. To preserve historical CertificateRequest revisions, explicitly set `revisionHistoryLimit` on Certificate resources before upgrading. Or set to a higher value to match previous behavior (unlimited retention not recommended due to resource accumulation). \n- The default value of `Certificate.Spec.PrivateKey.RotationPolicy` changed from `Never` to `Always` in v1.18.0. This is controlled by the feature gate `DefaultPrivateKeyRotationPolicyAlways` (beta, default. enabled). Private keys are now regenerated on every certificate renewal by default (previously they were reused). Existing Certificates without an explicit `rotationPolicy` field will rotate private keys on next issuance/renewal. Users who relied on stable private keys across certificate renewals will experience private key changes. Applications expecting private keys to remain constant may break if they cache or pin private key values. To preserve v1.17.x behavior and keep private keys stable across renewals, choose one of. Option 1. Set `rotationPolicy. Never` explicitly on each Certificate. Option 2. Disable the feature gate (Helm values) and add explicit `rotationPolicy. Never` before v1.19. Note. Feature gate will be GA in v1.19 and cannot be disabled after that. \n\n\n## 1.17\n\n- Starting in v1.17.0, cert-manager selects hash algorithms based on RSA key size for CA and SelfSigned issuers. RSA keys of 3072 bits now use SHA-384 (previously SHA-256), and RSA keys of 4096+ bits use SHA-512 (previously SHA-256). This change improves compliance with US DoD cryptography requirements. Existing certificates with 3072-bit RSA keys will use SHA-384 upon next renewal instead of SHA-256. Existing certificates with 4096+ bit RSA keys will use SHA-512 upon next renewal instead of SHA-256. Systems expecting SHA-256 signatures for larger RSA keys may fail validation. Certificate fingerprints and signatures will differ after renewal. Verify that downstream systems and trust stores support SHA-384 and SHA-512 signature algorithms. Test certificate validation in staging environments before renewal in production. No configuration change required; behavior is automatic based on key size. If SHA-256 is required, reduce RSA key size to 2048 bits (default). \n- The UseDomainQualifiedFinalizer feature gate was promoted to Beta and is now enabled by default. New ACME Challenge resources created in v1.17.0+ will have the finalizer `acme.cert-manager.io/finalizer` instead of the legacy `finalizer.acme.cert-manager.io`. Both finalizers are still recognized and handled correctly by cert-manager. New ACME Challenge resources use the new finalizer string `acme.cert-manager.io/finalizer`. External tools, scripts, or monitoring that check for the specific legacy finalizer string `finalizer.acme.cert-manager.io` may not recognize new challenges. Kubernetes no longer emits warnings about non-domain-qualified finalizers. Existing challenges with the legacy finalizer continue to work normally. Update external automation, scripts, or monitoring to recognize both finalizer strings:. Legacy: `finalizer.acme.cert-manager.io`. New: `acme.cert-manager.io/finalizer`. To continue using legacy finalizer, explicitly disable the feature gate: `--feature-gates=UseDomainQualifiedFinalizer=false`. No action required if not using external tooling that checks finalizer strings. \n- cert-manager maintainers no longer publish or maintain OperatorHub packages for cert-manager starting with v1.17.0. The last available version on OperatorHub is v1.16.5. The cert-manager-olm repository has been archived. No cert-manager releases v1.17.0 or later are available via OperatorHub. Cannot upgrade cert-manager to v1.17.x+ using OperatorHub on OpenShift or other platforms. Existing v1.16.5 or earlier installations from OperatorHub remain functional but cannot be upgraded via OperatorHub. Must switch to alternative installation methods (Helm, kubectl apply, cmctl) to upgrade past v1.16.5. Migrate from OperatorHub installation to one of the supported methods:. Helm chart: `helm install cert-manager jetstack/cert-manager`. Static manifests: `kubectl apply -f https://github.com/cert-manager/cert-manager/releases/download/vX.Y.Z/cert-manager.yaml`. cmctl: Use cert-manager CLI for installation. Plan migration before attempting upgrade to v1.17.0 or later. Review migration documentation at cert-manager.io for detailed steps. \n- Log messages across cert-manager components have been converted to structured logging format. Previously unstructured log messages now include contextual structured data as key-value pairs, changing the literal string format of many log lines. Log parsing scripts using literal string matching (e.g., `grep`, regex patterns) may break. Log aggregation and monitoring queries based on exact log message text will fail. SIEM rules and alerts matching specific log strings require updates. Structured log data provides better queryability but different query syntax. Update log parsing to extract structured key-value pairs instead of matching literal strings. Revise monitoring queries, alerts, and dashboards to use structured log fields. Test log collection pipelines in staging before upgrading production. If maintaining string-based parsing is critical, audit all log queries before upgrade. \n',
            type: 'text',
          },
          {
            links: [
              {
                text: 'cert-manager Release Notes',
                url: 'https://github.com/cert-manager/cert-manager/releases',
              },
            ],
            type: 'learn-more',
          },
        ],
        created: 0,
        updated: 0,
      },
      {
        step_number: 4,
        comments: {},
        name: 'Deprecations & Removals',
        owner: 'chkk',
        status: 'in-progress',
        allowed_action_types: [],
        content_blocks: [
          {
            style: 'markdown',
            text: '\n## 1.18\n\n- Removed the deprecated feature gate `ValidateCAA`; enabling it now has no effect and logs a warning. \n',
            type: 'text',
          },
          {
            links: [
              {
                text: 'cert-manager Release Notes',
                url: 'https://github.com/cert-manager/cert-manager/releases',
              },
            ],
            type: 'learn-more',
          },
        ],
        created: 0,
        updated: 0,
      },
      {
        step_number: 5,
        comments: {},
        name: 'Critical Bug Fixes',
        owner: 'chkk',
        status: 'in-progress',
        allowed_action_types: [],
        content_blocks: [
          {
            style: 'markdown',
            text: '\n## 1.18\n\n- Increases the ACME challenge authorization timeout to 2 minutes to resolve the "error waiting for authorization" issue, improving the reliability and success rate of ACME certificate issuance. [[1](https://github.com/cert-manager/cert-manager/pull/7801)]\n- When running with the `--namespace` flag, cert-manager limits its scope to the specified namespace and disables cluster-scoped controllers for proper isolation. \n- Resolved issues issuing certificates via DNS-01 challenges on Cloudflare after API changes, restoring functionality for Cloudflare users. \n- Corrected handling of certificates with IP addresses in the commonName field by placing IP addresses in the appropriate `ipAddresses` field instead of DNS SANs. \n\n\n## 1.17\n\n- The setting that controls when a certificate should be renewed (before it expires) now works as intended. If you set it to renew when, for example, 25% of the certificate\'s validity period remains, it will now correctly renew at that point. Previously, it was doing the opposite. \n- The version of the Venafi vCert library used by the system has been updated. This fixes a bug that prevented the enrollment of RSA certificates with a 3072-bit key size for Venafi TPP. \n- A problem introduced in v1.16.0 caused the ACME ClusterIssuer (a way to automatically get certificates) to look in the wrong place for certain necessary information. This issue is now fixed in v1.16.1 and v1.17.0 and later. \n\n\n## 1.16\n\n- A recent update to cert-manager (v1.16.4) includes a fix for a problem that arose when issuing website security certificates using a method called DNS01 challenge specifically with the service Cloudflare. This problem occurred because Cloudflare made a change to its system (API), which unfortunately broke the way cert-manager was issuing these certificates. The new version of cert-manager, v1.16.4, now corrects this issue. \n- The Helm chart schema validation has been adjusted to allow unknown fields in the shared "global" section, improving compatibility and preventing validation errors when deploying cert-manager Helm charts with additional global configuration fields. [[1](https://github.com/cert-manager/cert-manager/pull/7348)]\n- A bug that was introduced in cert-manager version 1.16.0 has been fixed in version 1.16.1. In the problematic version, a component of cert-manager called "ACME ClusterIssuer" was looking for important information (like login credentials stored as "Secrets") in the wrong area of your Kubernetes setup. This issue has now been resolved. \n- An update was made to the way cert-manager\'s internal upgrade process works. The change ensures that under the "global" settings in the configuration file (called `values.yaml`), you can no longer accidentally add extra configuration options that are not expected. \n',
            type: 'text',
          },
          {
            links: [
              {
                text: 'cert-manager Release Notes',
                url: 'https://github.com/cert-manager/cert-manager/releases',
              },
            ],
            type: 'learn-more',
          },
        ],
        created: 0,
        updated: 0,
      },
      {
        step_number: 6,
        comments: {},
        name: 'Notable Features',
        owner: 'chkk',
        status: 'in-progress',
        allowed_action_types: [],
        content_blocks: [
          {
            style: 'markdown',
            text: '\n## 1.18\n\n- Increases the maximum supported size for PEM certificates and chains, allowing the parsing of certificates with a large number of DNS names or identities. This improves reliability for environments requiring large certificates, such as Istio gateways. [[1](https://github.com/cert-manager/cert-manager/pull/7966)]\n- Added a Helm value `global.rbac.disableHTTPChallengesRole` to disable HTTP-01 ACME challenge permissions, enhancing security when HTTP-01 challenges are not needed. \n- Added support for the ACME profiles extension, allowing clients to select certificate profiles offered by ACME servers for tailored certificate requests. \n- Service and service monitor definitions now use port names instead of port numbers for better compatibility and clarity. \n- Promoted the `AdditionalCertificateOutputFormats` feature to general availability, enabling additional certificate output formats by default. \n\n\n## 1.17\n\n- The `CA NameConstraints` feature, which allows for restricting the scope of CA certificates, is now considered stable and will be enabled by default. \n\n\n## 1.16\n\n- When installing applications using Helm, you can now easily control whether cert-manager is installed as a dependency. By setting a specific value called "enabled," you can choose to either include or exclude cert-manager as part of the installation. \n- A new feature has been added to Helm that allows you to define the minimum and maximum number of running application instances (pods) using percentages. This applies to a setting called "podDisruptionBudget," which helps to maintain the availability of your applications during updates or maintenance. \n',
            type: 'text',
          },
          {
            links: [
              {
                text: 'cert-manager Release Notes',
                url: 'https://github.com/cert-manager/cert-manager/releases',
              },
            ],
            type: 'learn-more',
          },
        ],
        created: 0,
        updated: 0,
      },
    ],
    updated: 0,
  },
  {
    allowed_action_types: [],
    created: 0,
    name: 'Application Client Changes',
    stage_number: 2,
    status: 'in-progress',
    steps: [
      {
        step_number: 1,
        comments: {},
        name: 'cert-manager v1.18.0: Default RevisionHistoryLimit Change',
        owner: 'chkk',
        status: 'in-progress',
        allowed_action_types: [
          'skip',
          'undo-skip',
          'mark-completed',
          'undo-mark-completed',
        ],
        content_blocks: [
          {
            style: 'markdown',
            text: "\n\n\n\n### Overview\n\ncert-manager v1.18.0 introduces an important behavioral change for Certificate resource management. The `revisionHistoryLimit` field now defaults to `1` instead of `nil` (unlimited), meaning old CertificateRequest revisions will be automatically garbage collected to prevent resource accumulation in your cluster.\n\n### What Changed\n\n#### Previous Behavior (v1.17 and earlier)\n- `Certificate.spec.revisionHistoryLimit` defaulted to `nil` (no limit)\n- All CertificateRequest revisions were retained indefinitely\n- Manual cleanup or explicit configuration was required to prevent accumulation\n\n#### New Behavior (v1.18.0)\n- `Certificate.spec.revisionHistoryLimit` defaults to `1`\n- Only the most recent CertificateRequest revision is retained\n- Older revisions are automatically garbage collected\n- Garbage collection occurs only for Certificates in `Ready=True` state\n\n**Code References:**\n- [Controller implementation with new default](https://github.com/cert-manager/cert-manager/blob/v1.18.0/pkg/controller/certificates/revisionmanager/revisionmanager_controller.go#L136-L142)\n- [CRD specification update](https://github.com/cert-manager/cert-manager/blob/v1.18.0/deploy/crds/crd-certificates.yaml#L509-L511)\n- [API type definition](https://github.com/cert-manager/cert-manager/blob/v1.18.0/pkg/apis/certmanager/v1/types_certificate.go)\n\n### Impact Assessment\n\n#### Who Is Affected\n- All users with existing Certificate resources that don't explicitly set `revisionHistoryLimit`\n- Applications or workflows that depend on accessing historical CertificateRequest revisions\n- Monitoring or auditing systems that track certificate history\n\n#### What Will Happen on Upgrade\nWhen upgrading to cert-manager v1.18.0:\n1. Existing Certificates without an explicit `revisionHistoryLimit` will adopt the new default of `1`\n2. Upon the next reconciliation, older CertificateRequest revisions will be deleted\n3. Only the most recent CertificateRequest will remain for each Certificate\n\n### Pre-Upgrade Actions\n\n#### Step 1: Identify Affected Certificates\nList all Certificates that don't have an explicit `revisionHistoryLimit`:\n\n```bash\nkubectl get certificates -A -o json | jq -r '.items[] |\n  select(.spec.revisionHistoryLimit == null) |\n  \"\\(.metadata.namespace)/\\(.metadata.name)\"'\n```\n\n#### Step 2: Audit Historical Requirements\nFor each identified Certificate, determine if you need to:\n- Preserve historical CertificateRequest data for compliance\n- Maintain multiple revisions for rollback purposes\n- Keep audit trails of certificate renewals\n\n#### Step 3: Preserve History if Needed\nFor Certificates requiring history preservation, explicitly set the limit before upgrading:\n\n```yaml\napiVersion: cert-manager.io/v1\nkind: Certificate\nmetadata:\n  name: example-certificate\n  namespace: default\nspec:\n  # Preserve the previous unlimited behavior\n  revisionHistoryLimit: null\n  # Or set a specific limit\n  # revisionHistoryLimit: 10\n  secretname: example-tls\n  issuerRef:\n    name: example-issuer\n    kind: Issuer\n  dnsNames:\n  - example.com\n```\n\nApply the changes:\n```bash\nkubectl apply -f certificate.yaml\n```\n\n### Upgrade Process\n\n#### Step 1: Apply Pre-Upgrade Changes\nEnsure all necessary `revisionHistoryLimit` values are set as identified above.\n\n#### Step 2: Upgrade cert-manager\nFollow the standard cert-manager upgrade process to v1.18.0.\n\n#### Step 3: Verify Behavior\nAfter upgrade, monitor the CertificateRequest cleanup:\n\n```bash\n# Check CertificateRequests for a specific Certificate\nkubectl get certificaterequests -n <namespace> \\\n  -l cert-manager.io/certificate-name=<certificate-name> \\\n  --sort-by=.metadata.creationTimestamp\n```\n\n### Post-Upgrade Actions\n\n#### Validate Garbage Collection\nConfirm that old CertificateRequests are being removed:\n\n```bash\n# Monitor CertificateRequest count over time\nwatch \"kubectl get certificaterequests -A --no-headers | wc -l\"\n```\n\n#### Adjust Limits if Necessary\nIf you need to retain more history for specific Certificates:\n\n```yaml\napiVersion: cert-manager.io/v1\nkind: Certificate\nmetadata:\n  name: important-certificate\nspec:\n  revisionHistoryLimit: 5  # Keep last 5 revisions\n  # ... rest of spec\n```\n\n### Configuration Examples\n\n#### Example 1: Maintain Previous Behavior\nTo keep all CertificateRequest revisions (previous default):\n\n```yaml\napiVersion: cert-manager.io/v1\nkind: Certificate\nmetadata:\n  name: audit-required-cert\nspec:\n  revisionHistoryLimit: null  # Explicitly disable garbage collection\n  secretName: audit-tls\n  issuerRef:\n    name: production-issuer\n    kind: ClusterIssuer\n  dnsNames:\n  - audit.example.com\n```\n\n#### Example 2: Custom Retention Policy\nTo keep the last 3 revisions:\n\n```yaml\napiVersion: cert-manager.io/v1\nkind: Certificate\nmetadata:\n  name: standard-cert\nspec:\n  revisionHistoryLimit: 3  # Keep last 3 CertificateRequests\n  secretName: standard-tls\n  issuerRef:\n    name: production-issuer\n    kind: ClusterIssuer\n  dnsNames:\n  - app.example.com\n```\n\n#### Example 3: Accept New Default\nNo action needed - the Certificate will use the new default:\n\n```yaml\napiVersion: cert-manager.io/v1\nkind: Certificate\nmetadata:\n  name: simple-cert\nspec:\n  # revisionHistoryLimit not specified - will default to 1\n  secretName: simple-tls\n  issuerRef:\n    name: production-issuer\n    kind: ClusterIssuer\n  dnsNames:\n  - simple.example.com\n```\n\n### Troubleshooting\n\n#### Issue: Important Historical Data Lost\n**Symptom:** CertificateRequests were deleted before you could preserve them.\n\n**Solution:**\n1. Check if backups contain the deleted resources\n2. Set `revisionHistoryLimit: null` to prevent further deletions\n3. Restore from backups if available\n\n#### Issue: Unexpected Resource Cleanup\n**Symptom:** More CertificateRequests deleted than expected.\n\n**Solution:**\n1. Verify the Certificate's `revisionHistoryLimit` value:\n   ```bash\n   kubectl get certificate <name> -n <namespace> -o jsonpath='{.spec.revisionHistoryLimit}'\n   ```\n2. Adjust the limit if needed\n\n#### Issue: Compliance Requirements Not Met\n**Symptom:** Audit requirements need historical certificate data.\n\n**Solution:**\n1. Set appropriate `revisionHistoryLimit` values or `null` for unlimited\n2. Consider implementing external archival for CertificateRequest data\n3. Use monitoring tools to export certificate events\n\n### Rollback Instructions\n\nIf you need to rollback cert-manager after upgrade:\n\n1. **Before Rollback:** Export current CertificateRequests if needed:\n   ```bash\n   kubectl get certificaterequests -A -o yaml > certificaterequests-backup.yaml\n   ```\n\n2. **Rollback cert-manager** to the previous version\n\n3. **Restore Configuration:** Apply any Certificate modifications to restore previous `revisionHistoryLimit` settings\n\n### Best Practices\n\n#### For New Deployments\n- Accept the default of `1` for most use cases to prevent resource accumulation\n- Explicitly set higher limits only where historical data is required\n- Monitor cluster resources to ensure garbage collection is working\n\n#### For Existing Deployments\n- Audit your retention requirements before upgrading\n- Set explicit values where the default doesn't meet your needs\n- Document any Certificates requiring special retention policies\n\n#### Monitoring Recommendations\n- Set up alerts for CertificateRequest creation/deletion rates\n- Track the total number of CertificateRequests in your cluster\n- Monitor certificate renewal patterns\n\n### Additional Resources\n\n- [cert-manager v1.18.0 Release Notes](https://cert-manager.io/docs/release-notes/release-notes-1.18/)\n- [Certificate Resource Documentation](https://cert-manager.io/docs/usage/certificate/)\n- [CertificateRequest Documentation](https://cert-manager.io/docs/concepts/certificaterequest/)\n",
            type: 'text',
          },
        ],
        created: 0,
        updated: 0,
      },
      {
        step_number: 2,
        comments: {},
        name: 'cert-manager v1.18.0: Default Private Key Rotation Policy Changed to Always',
        owner: 'chkk',
        status: 'in-progress',
        allowed_action_types: [
          'skip',
          'undo-skip',
          'mark-completed',
          'undo-mark-completed',
        ],
        content_blocks: [
          {
            style: 'markdown',
            text: '\n\n### What Changed\n\ncert-manager v1.18.0 introduces a **breaking change** that modifies the default behavior for private key rotation. When you don\'t explicitly set the `rotationPolicy` field in your Certificate resources, cert-manager now defaults to rotating private keys on every certificate renewal (`Always`) instead of preserving existing keys (`Never`).\n\n### Impact Assessment\n\nThis change affects:\n\n- **All Certificate resources** where `spec.privateKey.rotationPolicy` is not explicitly set\n- **Ingress-based certificates** using cert-manager annotations without explicit rotation policy\n- **Applications** that depend on stable private keys across certificate renewals\n- **Infrastructure** that caches or references specific private keys\n\n### Components Being Updated\n\n#### Core API Changes\n- **Certificate API**: The [`CertificatePrivateKey`](https://github.com/cert-manager/cert-manager/blob/v1.18.0/pkg/apis/certmanager/v1/types_certificate.go#L293-L316) struct\'s `RotationPolicy` field default value changes\n- **Feature Gate**: New [`DefaultPrivateKeyRotationPolicyAlways`](https://github.com/cert-manager/cert-manager/blob/v1.18.0/internal/controller/feature/features.go#L134-L146) feature (enabled by default in Beta)\n- **Controller Logic**: The [keymanager controller](https://github.com/cert-manager/cert-manager/blob/v1.18.0/pkg/controller/certificates/keymanager/keymanager_controller.go#L133-L147) applies the new default\n\n#### Configuration Points\n- **Helm Chart**: Feature gate can be disabled via [`values.yaml`](https://github.com/cert-manager/cert-manager/blob/v1.18.0/deploy/charts/cert-manager/values.yaml#L136-L138)\n- **Direct Deployment**: Controller args support `--feature-gates` flag\n\n### Pre-Upgrade Actions\n\n#### Step 1: Audit Your Certificate Resources\n\nIdentify all Certificate resources without explicit rotation policies:\n\n```bash\nkubectl get certificates -A -o json | jq -r \'\n  .items[] |\n  select(.spec.privateKey.rotationPolicy == null) |\n  "\\(.metadata.namespace)/\\(.metadata.name)"\n\'\n```\n\n#### Step 2: Assess Impact on Your Applications\n\nFor each identified Certificate, determine if your application:\n- Caches the private key in memory\n- References the key by fingerprint or hash\n- Requires stable key material for external integrations\n- Uses pinning mechanisms that would break with key rotation\n\n#### Step 3: Choose Your Migration Strategy\n\n**Option A: Accept the New Default (Recommended)**\n- Provides better security through automatic key rotation\n- No configuration changes needed\n- Test applications to ensure they handle key changes gracefully\n\n**Option B: Preserve Current Behavior**\n- Explicitly set `rotationPolicy: Never` on affected Certificates\n- Maintains backward compatibility\n- Requires manual intervention for key rotation\n\n**Option C: Temporary Rollback**\n- Disable the feature gate during upgrade\n- Provides time to update Certificates\n- Must complete migration before v1.19.0\n\n### Upgrade Actions\n\n#### For Helm Users\n\n##### Option 1: Keep New Default Behavior (Recommended)\n```bash\nhelm upgrade cert-manager jetstack/cert-manager \\\n  --namespace cert-manager \\\n  --version v1.18.0\n```\n\n##### Option 2: Disable Feature Gate Temporarily\n```yaml\n# values.yaml\nconfig:\n  featureGates:\n    DefaultPrivateKeyRotationPolicyAlways: false\n```\n\n```bash\nhelm upgrade cert-manager jetstack/cert-manager \\\n  --namespace cert-manager \\\n  --version v1.18.0 \\\n  -f values.yaml\n```\n\n#### For Manifest Users\n\n##### Option 1: Keep New Default Behavior (Recommended)\n```bash\nkubectl apply -f https://github.com/cert-manager/cert-manager/releases/download/v1.18.0/cert-manager.yaml\n```\n\n##### Option 2: Disable Feature Gate\nEdit the controller deployment:\n```yaml\napiVersion: apps/v1\nkind: Deployment\nmetadata:\n  name: cert-manager\n  namespace: cert-manager\nspec:\n  template:\n    spec:\n      containers:\n      - name: cert-manager-controller\n        args:\n        - --v=2\n        - --cluster-resource-namespace=$(POD_NAMESPACE)\n        - --leader-election-namespace=kube-system\n        - --feature-gates=DefaultPrivateKeyRotationPolicyAlways=false  # Add this line\n```\n\n#### Updating Certificate Resources\n\n##### Preserve Existing Behavior\n```yaml\napiVersion: cert-manager.io/v1\nkind: Certificate\nmetadata:\n  name: example-cert\nspec:\n  secretname: example-cert-tls\n  privateKey:\n    rotationPolicy: Never  # Explicitly set to maintain old behavior\n  issuerRef:\n    name: letsencrypt-prod\n    kind: ClusterIssuer\n  dnsNames:\n  - example.com\n```\n\n##### Adopt New Behavior Explicitly\n```yaml\napiVersion: cert-manager.io/v1\nkind: Certificate\nmetadata:\n  name: example-cert\nspec:\n  secretName: example-cert-tls\n  privateKey:\n    rotationPolicy: Always  # Explicitly adopt new behavior\n  issuerRef:\n    name: letsencrypt-prod\n    kind: ClusterIssuer\n  dnsNames:\n  - example.com\n```\n\n### Post-Upgrade Actions\n\n#### Step 1: Verify Certificate Status\n\nCheck for warnings about rotation policy:\n```bash\nkubectl describe certificates -A | grep -A5 "Events:"\n```\n\nLook for warnings like:\n```\nWarning: spec.privateKey.rotationPolicy: In cert-manager >= v1.18.0, the default value changed from `Never` to `Always`.\n```\n\n#### Step 2: Monitor Key Rotation\n\nAfter the first certificate renewal, verify key rotation:\n```bash\n# Before renewal\nkubectl get secret <secret-name> -o json | jq -r \'.data."tls.key"\' | base64 -d | openssl rsa -noout -modulus | md5sum\n\n# Trigger renewal\ncmctl renew <certificate-name>\n\n# After renewal - hash should be different if rotation occurred\nkubectl get secret <secret-name> -o json | jq -r \'.data."tls.key"\' | base64 -d | openssl rsa -noout -modulus | md5sum\n```\n\n#### Step 3: Update Application Configuration\n\nIf your applications need adjustment:\n1. Update key loading logic to detect changes\n2. Implement graceful reload on Secret updates\n3. Remove any hardcoded key fingerprints\n\n### Common Issues and Solutions\n\n#### Issue: Application fails after certificate renewal\n**Symptom**: Application errors after automatic certificate renewal\n**Cause**: Application cached old private key\n**Solution**:\n- Implement Secret watch and reload mechanism\n- Or set `rotationPolicy: Never` temporarily while fixing application\n\n#### Issue: External systems reject new certificates\n**Symptom**: TLS handshake failures with partner systems\n**Cause**: Partner systems using key pinning\n**Solution**:\n- Set `rotationPolicy: Never` for affected certificates\n- Coordinate key rotation with external partners\n\n#### Issue: Webhook validation warnings\n**Symptom**: Warnings during Certificate creation\n**Resolution**: These are informational - explicitly set `rotationPolicy` to remove warnings\n\n### Validation Steps\n\n#### Confirm Feature Gate Status\n```bash\nkubectl logs -n cert-manager deployment/cert-manager -c cert-manager-controller | grep "feature gates"\n```\n\n#### Verify Certificate Defaults\n```bash\n# Create test certificate without rotationPolicy\ncat <<EOF | kubectl apply -f -\napiVersion: cert-manager.io/v1\nkind: Certificate\nmetadata:\n  name: test-rotation\n  namespace: default\nspec:\n  secretName: test-rotation-tls\n  issuerRef:\n    name: <your-issuer>\n    kind: Issuer\n  dnsNames:\n  - test.example.com\nEOF\n\n# Check applied default\nkubectl get certificate test-rotation -o jsonpath=\'{.spec.privateKey.rotationPolicy}\'\n# Should output: Always (if feature enabled) or empty (will use runtime default)\n```\n\n### Rollback Instructions\n\nIf issues arise post-upgrade:\n\n#### Immediate Rollback (Helm)\n```bash\nhelm rollback cert-manager -n cert-manager\n```\n\n#### Immediate Rollback (Manifests)\n```bash\nkubectl apply -f https://github.com/cert-manager/cert-manager/releases/download/v1.17.x/cert-manager.yaml\n```\n\n#### Gradual Migration Path\n1. Disable feature gate (shown above)\n2. Update all Certificates with explicit `rotationPolicy`\n3. Re-enable feature gate\n4. Remove explicit `Never` policies where rotation is acceptable\n\n### Security Considerations\n\nThe change to `rotationPolicy: Always` improves security by:\n- Automatically rotating potentially compromised keys\n- Reducing key exposure window\n- Aligning with security best practices\n\nConsider keeping the new default unless you have specific requirements for key stability.\n\n### Migration Timeline\n\n- **v1.18.0**: Feature in Beta, enabled by default, can be disabled\n- **v1.19.0**: Feature becomes GA, cannot be disabled\n- **Action Required**: Set explicit `rotationPolicy` before v1.19.0 if you need `Never` behavior\n\n### Additional Resources\n\n- [cert-manager API Reference](https://cert-manager.io/docs/reference/api-docs/#cert-manager.io/v1.CertificatePrivateKey)\n- [Private Key Rotation Documentation](https://cert-manager.io/docs/usage/certificate/#issuance-behavior-rotation-of-the-private-key)\n- [Component Configuration](https://cert-manager.io/docs/installation/configuring-components/)\n- [GitHub Issue #7601](https://github.com/cert-manager/cert-manager/issues/7601) - Original proposal discussion\n',
            type: 'text',
          },
        ],
        created: 0,
        updated: 0,
      },
      {
        step_number: 3,
        comments: {},
        name: 'cert-manager v1.18.0: IP Address CommonName Handling Fix',
        owner: 'chkk',
        status: 'in-progress',
        allowed_action_types: [
          'skip',
          'undo-skip',
          'mark-completed',
          'undo-mark-completed',
        ],
        content_blocks: [
          {
            style: 'markdown',
            text: '\n\n### Overview\n\ncert-manager v1.18.0 fixes a bug where IP addresses specified in a certificate\'s `commonName` field were incorrectly added to the DNS Subject Alternative Names (SANs) instead of the IP Address SANs. This caused ACME validation failures when requesting certificates for IP addresses.\n\n**Impact Assessment**: This fix only affects certificates using ACME issuers where:\n- The `commonName` field contains an IP address (e.g., `10.0.0.1` or `192.168.1.100`)\n- The certificate is being issued through Let\'s Encrypt or other ACME providers\n\n### What Changed\n\nPreviously, cert-manager would incorrectly process IP addresses in the `commonName` field:\n- **Before**: IP addresses in `commonName` → Added to DNS SANs → ACME validation failure\n- **After**: IP addresses in `commonName` → Properly validated and added to IP Address SANs → Successful validation\n\nThe fix modifies the internal ACME order processing logic ([sync.go](https://github.com/cert-manager/cert-manager/blob/v1.18.0/pkg/controller/acmeorders/sync.go#L268-L272)) to prevent automatic addition of `commonName` to DNS identifiers.\n\n### User Action Required\n\n#### Pre-Upgrade Assessment\n\nCheck if you have certificates with IP addresses in the `commonName` field:\n\n```bash\n# List all certificates with IP addresses in spec\nkubectl get certificates -A -o json | jq -r \'.items[] |\n  select(.spec.commonName // "" | test("^[0-9]{1,3}\\\\.[0-9]{1,3}\\\\.[0-9]{1,3}\\\\.[0-9]{1,3}$")) |\n  "\\(.metadata.namespace)/\\(.metadata.name): commonName=\\(.spec.commonName)"\'\n```\n\n#### Configuration Validation\n\nEnsure your Certificate resources with IP addresses follow this pattern:\n\n**Correct Configuration** (works before and after upgrade):\n```yaml\napiVersion: cert-manager.io/v1\nkind: Certificate\nmetadata:\n  name: ip-certificate\nspec:\n  commonname: "192.168.1.100"  # IP address as commonName\n  ipAddresses:                  # MUST include the commonName IP here\n    - "192.168.1.100"\n    - "10.0.0.1"                # Additional IPs if needed\n  issuerRef:\n    name: letsencrypt-staging\n    kind: ClusterIssuer\n  secretName: ip-cert-tls\n```\n\n**Important**: Per the [Certificate API specification](https://github.com/cert-manager/cert-manager/blob/v1.18.0/pkg/apis/certmanager/v1/types_certificate.go#L147-L155), if `commonName` contains an IP address, that same IP MUST be listed in the `ipAddresses` field.\n\n#### No Configuration Changes Required If\n\nYour certificates already correctly specify IP addresses in both fields:\n- `commonName` contains the IP address\n- `ipAddresses` array includes the same IP address\n\nThese configurations will continue to work without modification.\n\n### Validation Steps\n\nAfter upgrading to v1.18.0:\n\n1. **Check certificate issuance status**:\n   ```bash\n   kubectl get certificates -A -o wide\n   ```\n   Look for any certificates in non-Ready state.\n\n2. **Verify ACME orders for IP certificates**:\n   ```bash\n   kubectl get orders.acme.cert-manager.io -A | grep -E "192\\.168|10\\.|172\\."\n   ```\n   Ensure orders are in `valid` state.\n\n3. **Inspect certificate details**:\n   ```bash\n   # For each IP-based certificate\n   kubectl describe certificate <name> -n <namespace>\n   ```\n   Check that the `Status` shows `Ready: True` and recent renewal succeeded.\n\n4. **Verify the issued certificate has correct SANs**:\n   ```bash\n   # Extract and decode the certificate\n   kubectl get secret <secret-name> -n <namespace> -o jsonpath=\'{.data.tls\\.crt}\' | \\\n     base64 -d | openssl x509 -text -noout | grep -A2 "Subject Alternative Name"\n   ```\n   Ensure IP addresses appear under `IP Address:` not `DNS:`.\n\n### Troubleshooting\n\n#### Certificate Stuck in Pending State\n\nIf a certificate with IP `commonName` fails after upgrade:\n\n1. Check if the IP is in `ipAddresses` field:\n   ```bash\n   kubectl get certificate <name> -n <namespace> -o jsonpath=\'{.spec.ipAddresses}\'\n   ```\n\n2. If missing, update the certificate:\n   ```bash\n   kubectl patch certificate <name> -n <namespace> --type=\'json\' \\\n     -p=\'[{"op": "add", "path": "/spec/ipAddresses", "value": ["<IP-ADDRESS>"]}]\'\n   ```\n\n3. Delete the failed order to trigger retry:\n   ```bash\n   kubectl delete orders.acme.cert-manager.io -n <namespace> -l cert-manager.io/certificate-name=<name>\n   ```\n\n#### ACME Challenge Failures\n\nIf you see errors like `urn:ietf:params:acme:error:malformed`:\n- Verify the IP address format is correct (no leading zeros: use `10.0.0.1` not `10.000.000.001`)\n- Ensure the IP address is publicly routable if using production ACME providers\n- Check that the ACME issuer supports IP address certificates (Let\'s Encrypt does as of 2024)\n\n### Rollback Instructions\n\nIf issues occur after upgrade:\n\n1. **Immediate rollback** (if critical issues):\n   ```bash\n   # Downgrade cert-manager to previous version\n   kubectl apply -f https://github.com/cert-manager/cert-manager/releases/download/v1.17.x/cert-manager.yaml\n   ```\n\n2. **Temporary workaround** (without downgrade):\n   - Remove `commonName` field from affected certificates\n   - Keep only `ipAddresses` field populated\n   - This works in both old and new versions\n\n### Additional Resources\n\n- [Certificate API Reference](https://github.com/cert-manager/cert-manager/blob/v1.18.0/pkg/apis/certmanager/v1/types_certificate.go#L205-L207) - IP address field specification\n- [ACME Order Types](https://github.com/cert-manager/cert-manager/blob/v1.18.0/pkg/apis/acme/v1/types_order.go) - Order specification showing separation of DNS and IP identifiers\n- [Bug Fix PR #7081](https://github.com/cert-manager/cert-manager/pull/7081) - Original pull request with detailed discussion\n',
            type: 'text',
          },
        ],
        created: 0,
        updated: 0,
      },
      {
        step_number: 4,
        comments: {},
        name: 'cert-manager v1.17.0: Structured Logging Format Change',
        owner: 'chkk',
        status: 'in-progress',
        allowed_action_types: [
          'skip',
          'undo-skip',
          'mark-completed',
          'undo-mark-completed',
        ],
        content_blocks: [
          {
            style: 'markdown',
            text: '\n\n### Overview\n\ncert-manager v1.17.0 introduces a **potentially breaking change** to log message formatting. All previously unstructured log messages have been replaced with structured logs. This change affects applications that parse cert-manager logs for monitoring, alerting, or debugging purposes.\n\n### Impact Assessment\n\n#### Affected Components\n- **cert-manager controller** - Main controller component log output\n- **cert-manager webhook** - Webhook validation component logs\n- **cert-manager cainjector** - CA injection component logs\n- **Any monitoring/observability tools** parsing cert-manager logs\n\n#### What Changed\nPreviously unstructured log messages like:\n```\ncert-manager-issuer-name: Failed to initialize Vault client: connection refused\n```\n\nAre now structured as:\n```\n{"level":"warn","msg":"Failed to initialize Vault client","issuer":{"name":"cert-manager-issuer-name","namespace":"default"},"err":"connection refused"}\n```\n\nKey changes include:\n- Log messages are now key-value pairs instead of concatenated strings\n- Error details are separated into distinct fields (`err`, `error`)\n- Resource references use structured objects (`issuer`, `challenge`, etc.)\n- Consistent field naming across all components\n\n### Pre-Upgrade Actions\n\n#### Step 1: Audit Your Log Parsing Dependencies\nReview all systems that consume cert-manager logs:\n- Log aggregation systems (Elasticsearch, Splunk, Datadog)\n- Monitoring alerts based on log patterns\n- Custom scripts parsing cert-manager logs\n- Dashboards displaying log metrics\n\n#### Step 2: Identify Pattern Matches\nSearch for any log parsing rules matching patterns like:\n- String contains checks: `"Failed to initialize Vault client:"`\n- Regular expressions: `/^[^:]+: (.+)$/`\n- Field extractions based on colon delimiters\n- Line-based parsing expecting specific formats\n\n#### Step 3: Test in Non-Production\nDeploy cert-manager v1.17.0 in a test environment and verify:\n```bash\n# Check controller logs\nkubectl logs -n cert-manager deployment/cert-manager -f\n\n# Check webhook logs\nkubectl logs -n cert-manager deployment/cert-manager-webhook -f\n\n# Check cainjector logs\nkubectl logs -n cert-manager deployment/cert-manager-cainjector -f\n```\n\n### Upgrade Actions\n\n#### Step 1: Update Log Parsing Rules\nTransform your log parsing from string matching to structured field extraction:\n\n**Before (string matching):**\n```yaml\n# Example Prometheus alert rule\nalert: VaultConnectionFailed\nexpr: |\n  rate(log_lines_total{\n    app="cert-manager",\n    message=~".*Failed to initialize Vault client.*"\n  }[5m]) > 0\n```\n\n**After (structured fields):**\n```yaml\n# Updated for structured logs\nalert: VaultConnectionFailed\nexpr: |\n  rate(log_lines_total{\n    app="cert-manager",\n    msg="Failed to initialize Vault client"\n  }[5m]) > 0\n```\n\n#### Step 2: Configure Log Format (Optional)\ncert-manager supports both `text` and `json` log formats. Configure via Helm values:\n\n**Helm values.yaml:**\n```yaml\n# For controller configuration\nconfig:\n  apiVersion: controller.config.cert-manager.io/v1alpha1\n  kind: ControllerConfiguration\n  logging:\n    verbosity: 2\n    format: text  # or "json" for structured JSON logs\n\n# For cainjector configuration\ncainjector:\n  config:\n    apiVersion: cainjector.config.cert-manager.io/v1alpha1\n    kind: CAInjectorConfiguration\n    logging:\n      verbosity: 2\n      format: text  # or "json" for structured JSON logs\n```\n\nReference: [values.yaml configuration](https://github.com/cert-manager/cert-manager/blob/v1.17.0/deploy/charts/cert-manager/values.yaml#L223-L227)\n\n#### Step 3: Update Monitoring Queries\nUpdate your monitoring queries to use structured fields:\n\n**Log aggregation query examples:**\n\nElasticsearch/OpenSearch:\n```json\n// Before\n{\n  "query": {\n    "match": {\n      "message": "Failed to initialize Vault client"\n    }\n  }\n}\n\n// After\n{\n  "query": {\n    "bool": {\n      "must": [\n        {"match": {"msg": "Failed to initialize Vault client"}},\n        {"exists": {"field": "err"}}\n      ]\n    }\n  }\n}\n```\n\n### Post-Upgrade Actions\n\n#### Validation Steps\n1. **Verify log output format:**\n   ```bash\n   # Check for structured log fields\n   kubectl logs -n cert-manager deployment/cert-manager | head -20\n   ```\n\n2. **Confirm alerts are firing:**\n   - Trigger a known error condition\n   - Verify alerts based on logs still activate\n   - Check log aggregation pipelines are processing logs\n\n3. **Monitor for parsing errors:**\n   - Check log ingestion pipelines for errors\n   - Verify no logs are being dropped\n   - Confirm dashboards display expected metrics\n\n### Troubleshooting\n\n#### Common Issues and Solutions\n\n**Issue: Alerts not firing after upgrade**\n- **Solution:** Update alert rules to match new structured fields instead of message strings\n\n**Issue: Log parsers failing with parse errors**\n- **Solution:** Switch from regex/delimiter-based parsing to JSON parsing for structured logs\n\n**Issue: Missing log data in dashboards**\n- **Solution:** Update field mappings in your visualization tools to use new field names\n\n**Issue: Need to maintain backward compatibility temporarily**\n- **Solution:** Run both old and new cert-manager versions in parallel during transition, or maintain dual parsing rules\n\n### Rollback Instructions\n\nIf critical issues arise:\n\n1. **Revert cert-manager version:**\n   ```bash\n   helm upgrade cert-manager jetstack/cert-manager \\\n     --namespace cert-manager \\\n     --version v1.16.2 \\\n     --values your-values.yaml\n   ```\n\n2. **Restore original log parsing rules**\n\n3. **Verify system stability:**\n   ```bash\n   kubectl get pods -n cert-manager\n   kubectl logs -n cert-manager -l app.kubernetes.io/name=cert-manager\n   ```\n\n### Technical Details\n\nThe change was implemented in [PR #7461](https://github.com/cert-manager/cert-manager/pull/7461), removing the `logs.V()` function that produced unstructured output and replacing all logging calls with structured `logr` based logging.\n\n**Code changes reference:** [pkg/logs/logs.go](https://github.com/cert-manager/cert-manager/blob/v1.17.0/pkg/logs/logs.go)\n\nThe structured logging now provides:\n- Consistent key-value pairs for all log messages\n- Proper error field separation\n- Resource object references as structured data\n- Machine-readable format for better observability\n\n### Resources\n\n- [cert-manager Helm Chart Values](https://github.com/cert-manager/cert-manager/blob/v1.17.0/deploy/charts/cert-manager/values.yaml)\n- [Structured Logging PR #7461](https://github.com/cert-manager/cert-manager/pull/7461)\n- [cert-manager Documentation](https://cert-manager.io/docs/)\n',
            type: 'text',
          },
        ],
        created: 0,
        updated: 0,
      },
      {
        step_number: 5,
        comments: {},
        name: 'cert-manager v1.17.0: SHA Algorithm Update for RSA Keys in CA and SelfSigned Issuers',
        owner: 'chkk',
        status: 'in-progress',
        allowed_action_types: [
          'skip',
          'undo-skip',
          'mark-completed',
          'undo-mark-completed',
        ],
        content_blocks: [
          {
            style: 'markdown',
            text: '\n\n### What Changed\n\ncert-manager v1.17.0 introduces an automatic hash algorithm selection for certificate signing operations when using **CA** and **SelfSigned** issuers with RSA keys. The change affects how certificates are signed based on the RSA key size:\n\n- **RSA keys ≥ 4096 bits**: Now use SHA-512 (previously SHA-256)\n- **RSA keys ≥ 3072 bits**: Now use SHA-384 (previously SHA-256)\n- **RSA keys 2048 bits**: Continue using SHA-256 (no change)\n\n**Code References:**\n- Implementation: [`pkg/util/pki/csr.go`](https://github.com/cert-manager/cert-manager/blob/v1.17.0/pkg/util/pki/csr.go#L246-L257)\n- CA Issuer: [`pkg/controller/certificaterequests/ca/ca.go`](https://github.com/cert-manager/cert-manager/blob/v1.17.0/pkg/controller/certificaterequests/ca/ca.go)\n- SelfSigned Issuer: [`pkg/controller/certificaterequests/selfsigned/selfsigned.go`](https://github.com/cert-manager/cert-manager/blob/v1.17.0/pkg/controller/certificaterequests/selfsigned/selfsigned.go)\n\n### Who Is Affected\n\nYou are affected by this change if ALL of the following conditions are true:\n\n1. You use cert-manager\'s **CA** or **SelfSigned** issuers\n2. Your CA certificate uses an RSA key of 3072 bits or larger\n3. Your applications or infrastructure components consume certificates signed by these issuers\n\nYou are **NOT** affected if:\n- You use ACME, Vault, Venafi, or other external issuers\n- Your CA certificates use RSA keys of 2048 bits or smaller\n- Your CA certificates use ECDSA keys (no changes to ECDSA signing)\n\n### Impact Assessment\n\n#### Potential Compatibility Issues\n\nApplications and systems consuming certificates from affected issuers must support the new hash algorithms. Systems that may have compatibility issues include:\n\n- **Legacy applications** that only support SHA-256\n- **Older TLS libraries** (e.g., OpenSSL < 1.0.0)\n- **Hardware security modules (HSMs)** with limited algorithm support\n- **Embedded systems** or IoT devices with cryptographic constraints\n- **Certificate validation tools** that don\'t recognize SHA-384/SHA-512\n\n#### How to Check Your Current Setup\n\n##### Step 1: Identify CA and SelfSigned Issuers\n\n```bash\n# List all CA issuers\nkubectl get issuers,clusterissuers -A -o json | jq -r \'.items[] | select(.spec.ca != null) | "\\(.kind)/\\(.metadata.namespace // "cluster")/\\(.metadata.name)"\'\n\n# List all SelfSigned issuers\nkubectl get issuers,clusterissuers -A -o json | jq -r \'.items[] | select(.spec.selfSigned != null) | "\\(.kind)/\\(.metadata.namespace // "cluster")/\\(.metadata.name)"\'\n```\n\n##### Step 2: Check RSA Key Sizes of CA Certificates\n\nFor each CA issuer, check the key size of the signing certificate:\n\n```bash\n# For a CA issuer in namespace \'cert-manager\' with secret \'ca-key-pair\'\nkubectl get secret ca-key-pair -n cert-manager -o json | \\\n  jq -r \'.data."tls.crt" // .data."ca.crt"\' | \\\n  base64 -d | \\\n  openssl x509 -text -noout | \\\n  grep "Public-Key:"\n```\n\n##### Step 3: Verify Current Signature Algorithms\n\nCheck the signature algorithm of existing certificates:\n\n```bash\n# Check a certificate\'s signature algorithm\nkubectl get secret <certificate-secret> -n <namespace> -o json | \\\n  jq -r \'.data."tls.crt"\' | \\\n  base64 -d | \\\n  openssl x509 -text -noout | \\\n  grep "Signature Algorithm:"\n```\n\n### Pre-Upgrade Actions\n\n#### 1. Inventory Your Infrastructure\n\nCreate a list of all systems that consume certificates from affected issuers:\n- Web servers (nginx, Apache, IIS)\n- Application servers (Tomcat, WebLogic)\n- Load balancers\n- Service meshes\n- Database connections using TLS\n- Custom applications\n\n#### 2. Test Compatibility\n\nBefore upgrading, test SHA-384/SHA-512 support in your infrastructure:\n\n```bash\n# Generate test certificates with different algorithms\n# SHA-384 test certificate\nopenssl req -x509 -sha384 -nodes -days 1 -newkey rsa:3072 \\\n  -keyout test-sha384.key -out test-sha384.crt \\\n  -subj "/CN=test-sha384"\n\n# SHA-512 test certificate\nopenssl req -x509 -sha512 -nodes -days 1 -newkey rsa:4096 \\\n  -keyout test-sha512.key -out test-sha512.crt \\\n  -subj "/CN=test-sha512"\n```\n\nDeploy these test certificates to non-production environments and verify:\n- TLS connections establish successfully\n- Certificate validation passes\n- No errors in application logs\n\n#### 3. Update Incompatible Systems\n\nIf compatibility issues are found:\n- **Update TLS libraries** to versions supporting SHA-384/SHA-512\n- **Upgrade applications** to newer versions\n- **Replace legacy systems** that cannot be updated\n\n### Migration Options\n\n#### Option 1: Maintain SHA-256 (Recommended for Compatibility)\n\nIf you need to maintain SHA-256 for compatibility, reduce your CA key size to 2048 bits:\n\n```yaml\napiVersion: cert-manager.io/v1\nkind: Certificate\nmetadata:\n  name: ca-certificate\nspec:\n  secretname: ca-key-pair\n  isCA: true\n  privateKey:\n    algorithm: RSA\n    size: 2048  # Forces SHA-256 usage\n  issuerRef:\n    name: selfsigned-issuer\n    kind: Issuer\n```\n\n#### Option 2: Gradual Migration\n\n1. Create parallel issuers with different key sizes:\n\n```yaml\n# SHA-256 issuer (2048-bit)\napiVersion: cert-manager.io/v1\nkind: Issuer\nmetadata:\n  name: ca-issuer-sha256\nspec:\n  ca:\n    secretName: ca-key-pair-2048\n\n---\n# SHA-512 issuer (4096-bit)\napiVersion: cert-manager.io/v1\nkind: Issuer\nmetadata:\n  name: ca-issuer-sha512\nspec:\n  ca:\n    secretName: ca-key-pair-4096\n```\n\n2. Migrate applications gradually by updating Certificate resources to use the appropriate issuer\n\n#### Option 3: Accept the Change\n\nIf all systems support SHA-384/SHA-512, no action is required. The change will be applied automatically upon upgrade.\n\n### Post-Upgrade Validation\n\n#### 1. Verify New Certificates\n\nAfter upgrading to v1.17.0, check that new certificates use expected algorithms:\n\n```bash\n# Force certificate renewal\nkubectl cert-manager renew <certificate-name> -n <namespace>\n\n# Check the signature algorithm\nkubectl get secret <certificate-secret> -n <namespace> -o json | \\\n  jq -r \'.data."tls.crt"\' | \\\n  base64 -d | \\\n  openssl x509 -text -noout | \\\n  grep "Signature Algorithm:"\n```\n\nExpected output:\n- 4096-bit RSA keys: `Signature Algorithm: sha512WithRSAEncryption`\n- 3072-bit RSA keys: `Signature Algorithm: sha384WithRSAEncryption`\n- 2048-bit RSA keys: `Signature Algorithm: sha256WithRSAEncryption`\n\n#### 2. Monitor Application Logs\n\nCheck for TLS-related errors in:\n- Application logs\n- Ingress controller logs\n- Service mesh logs\n- System logs\n\nCommon error patterns to watch for:\n- `unsupported signature algorithm`\n- `certificate verification failed`\n- `handshake failure`\n\n#### 3. Test End-to-End Connectivity\n\nVerify all TLS connections work correctly:\n\n```bash\n# Test HTTPS endpoint\ncurl -v https://<your-service>\n\n# Check certificate chain\nopenssl s_client -connect <your-service>:443 -showcerts\n```\n\n### Rollback Plan\n\nIf issues arise after upgrading:\n\n#### Immediate Rollback\n\n1. Downgrade cert-manager to the previous version\n2. Certificates will continue using existing signature algorithms\n3. New certificates will revert to SHA-256\n\n#### Alternative: Override Key Sizes\n\nWithout rolling back cert-manager, recreate CA certificates with 2048-bit keys:\n\n```bash\n# Delete existing CA certificate\nkubectl delete certificate ca-certificate -n <namespace>\n\n# Recreate with 2048-bit key (forces SHA-256)\nkubectl apply -f ca-certificate-2048.yaml\n```\n\n### Troubleshooting\n\n#### Issue: "Unsupported signature algorithm" errors\n\n**Solution:** Update the affected system\'s TLS library or use a 2048-bit CA key\n\n#### Issue: Certificate validation failures in legacy systems\n\n**Solution:**\n1. Check if the system supports SHA-384/SHA-512\n2. If not, use Option 1 (maintain SHA-256) from Migration Options\n\n#### Issue: Intermittent TLS handshake failures\n\n**Solution:**\n1. Verify all systems in the certificate chain support the new algorithms\n2. Check for mixed certificate versions (some SHA-256, some SHA-512)\n\n### Security Benefits\n\nThis change enhances security by:\n- **Stronger collision resistance** with SHA-384/SHA-512\n- **Future-proofing** against advances in cryptanalysis\n- **Compliance** with modern security standards recommending stronger hash algorithms for larger keys\n- **Alignment** with industry best practices for RSA key and hash algorithm pairing\n\n### Additional Resources\n\n- [cert-manager PR #7368](https://github.com/cert-manager/cert-manager/pull/7368) - Implementation details\n- [cert-manager v1.17.0 Release Notes](https://cert-manager.io/docs/release-notes/release-notes-1.17/)\n- [RFC 5280](https://datatracker.ietf.org/doc/html/rfc5280) - X.509 certificate standards\n- [NIST SP 800-57](https://nvlpubs.nist.gov/nistpubs/SpecialPublications/NIST.SP.800-57pt1r5.pdf) - Key management recommendations\n',
            type: 'text',
          },
        ],
        created: 0,
        updated: 0,
      },
    ],
    updated: 0,
  },
  {
    allowed_action_types: [],
    created: 0,
    name: 'Preparation',
    stage_number: 3,
    status: 'in-progress',
    steps: [
      {
        step_number: 1,
        comments: {},
        name: 'Setup Environment',
        owner: 'chkk',
        status: 'in-progress',
        allowed_action_types: [
          'skip',
          'undo-skip',
          'mark-completed',
          'undo-mark-completed',
        ],
        content_blocks: [
          {
            style: 'markdown',
            text: '\n\nBefore proceeding, confirm that required tools are installed and that the target artifacts are available for the release you plan to deploy.\n\nPrerequisites\n\n  - Cluster access: `kubectl` (or equivalent) installed and authenticated for the target cluster/context.\n  - CLI/utilities: any project-specific CLIs or plugins required by your workflows are installed and on PATH.\n  - Images/packages: target release images or packages exist in your registry/repository (or are reachable from the runtime environment).\n  - Permissions: your user or automation identity has rights to read/write the relevant namespaces, CRDs (if applicable), and CI/CD systems.\n\nVerify\n\n  - Current context points to the intended cluster.\n  - Required network egress to registries/repositories is permitted.\n  - Quotas/limits allow rolling updates without resource starvation.\n',
            type: 'text',
          },
        ],
        created: 0,
        updated: 0,
      },
      {
        step_number: 2,
        comments: {},
        name: 'Schedule Maintenance Window',
        badges: [
          {
            text: 'Optional',
            variant: 'neutral',
          },
        ],
        owner: 'chkk',
        status: 'in-progress',
        allowed_action_types: [
          'skip',
          'undo-skip',
          'mark-completed',
          'undo-mark-completed',
        ],
        content_blocks: [
          {
            style: 'markdown',
            text: 'Plan a maintenance window for environments where brief control-plane or admission changes could affect create/update operations.\n\nGuidance\n\n- Choose a window that accommodates rollout, validation, and rollback buffer.\n- Announce a temporary pause for configuration changes that rely on controllers, webhooks, or admission (if applicable).\n- Ensure change-freeze and backout criteria are documented and approved.\n\nRecord\n\n- Environment and cluster in scope.\n- Window start/end (with timezone).\n- Rollback window and approvers.\n\n',
            type: 'text',
          },
        ],
        created: 0,
        updated: 0,
      },
      {
        step_number: 3,
        comments: {},
        name: 'Notify Stakeholders',
        badges: [
          {
            text: 'Optional',
            variant: 'neutral',
          },
        ],
        owner: 'chkk',
        status: 'in-progress',
        allowed_action_types: [
          'skip',
          'undo-skip',
          'mark-completed',
          'undo-mark-completed',
        ],
        content_blocks: [
          {
            style: 'markdown',
            text: 'Inform relevant stakeholders about the upcoming change and expected impact so they can plan appropriately.\n\nInclude in the notice\n\n- What: upgrade `cert-manager` from `1.16.0` to ` 1.19.1`.\n- When: maintenance window start/end (timezone) and expected duration.\n- Where: environment(s), cluster(s), and namespaces (if scoped).\n- Impact: expected behavior during rollout (e.g., brief pauses in controller-driven operations; no impact to existing running workloads).\n- Status channel: link to the live updates channel (chat, incident room, or runbook page).\n\nAsk recipients to confirm awareness if they own dependent services or workflows.\n\n',
            type: 'text',
          },
        ],
        created: 0,
        updated: 0,
      },
    ],
    updated: 0,
  },
  {
    allowed_action_types: [],
    created: 0,
    name: 'IaC Diff & Pull Requests',
    stage_number: 4,
    status: 'in-progress',
    steps: [
      {
        step_number: 1,
        comments: {},
        name: 'Package Change Summary',
        owner: 'chkk',
        status: 'in-progress',
        allowed_action_types: [
          'skip',
          'undo-skip',
          'mark-completed',
          'undo-mark-completed',
        ],
        content_blocks: [
          {
            style: 'markdown',
            text: '\n',
            type: 'text',
          },
          {
            column_definitions: [
              {
                title: 'Attribute',
              },
              {
                title: 'Current',
              },
              {
                title: 'Target',
              },
            ],
            data: [
              [
                {
                  value: 'Package System',
                },
                {
                  value: 'helm',
                },
                {
                  value: 'helm',
                },
              ],
              [
                {
                  value: 'Package Name',
                },
                {
                  value: 'https://charts.jetstack.io/cert-manager',
                },
                {
                  value: 'https://charts.jetstack.io/cert-manager',
                },
              ],
              [
                {
                  value: 'Package Version',
                },
                {
                  value: '1.16.0',
                },
                {
                  value: '1.19.1',
                },
              ],
            ],
            type: 'table',
          },
          {
            style: 'markdown',
            text: '\n\n\n',
            type: 'text',
          },
        ],
        created: 0,
        updated: 0,
      },
      {
        step_number: 2,
        comments: {},
        name: 'IaC Diff',
        owner: 'chkk',
        status: 'in-progress',
        allowed_action_types: [
          'skip',
          'undo-skip',
          'mark-completed',
          'undo-mark-completed',
        ],
        content_blocks: [
          {
            style: 'markdown',
            text: '# Values YAML Diff\n\nRefer to the following diff for the values.yaml file that will be used to upgrade the package.\n\n```diff\n@@ (root level) @@\n! + one map entry added:\n+   enabled: true\n\n@@ global @@\n! + one map entry added:\n+   nodeSelector: {}\n\n@@ prometheus.servicemonitor.targetPort @@\n! ± type change from int to string\n- 9402\n+ http-metrics\n\n@@ webhook.networkPolicy.egress.0.to @@\n! + one list entry added:\n+   - ipBlock:\n+       cidr: "::/0"\n\n@@ webhook.networkPolicy.ingress.0.from @@\n! + one list entry added:\n+   - ipBlock:\n+       cidr: "::/0"\n```\n\n# Resources Diff\n\n## Deletions\n\nThe following resources are deleted:\n',
            type: 'text',
          },
          {
            column_definitions: [
              {
                title: 'API Version',
              },
              {
                title: 'Kind',
              },
              {
                title: 'Name',
              },
            ],
            data: [
              [
                {
                  value: 'rbac.authorization.k8s.io/v1',
                },
                {
                  value: 'RoleBinding',
                },
                {
                  value: 'cert-manager-kube-inspect-cert-manager-tokenrequest',
                },
              ],
            ],
            type: 'table',
          },
          {
            style: 'markdown',
            text: '\n\n## Additions\n\nThe following resources are added:\n',
            type: 'text',
          },
          {
            column_definitions: [
              {
                title: 'API Version',
              },
              {
                title: 'Kind',
              },
              {
                title: 'Name',
              },
            ],
            data: [
              [
                {
                  value: 'rbac.authorization.k8s.io/v1',
                },
                {
                  value: 'RoleBinding',
                },
                {
                  value: 'cert-manager-tokenrequest',
                },
              ],
            ],
            type: 'table',
          },
          {
            style: 'markdown',
            text: '\n\n## Changes\n\nThe following resources are changed:\n',
            type: 'text',
          },
          {
            column_definitions: [
              {
                title: 'API Version',
              },
              {
                title: 'Kind',
              },
              {
                title: 'Name',
              },
            ],
            data: [
              [
                {
                  value: 'admissionregistration.k8s.io/v1',
                },
                {
                  value: 'MutatingWebhookConfiguration',
                },
                {
                  value: 'cert-manager-webhook',
                },
              ],
              [
                {
                  value: 'admissionregistration.k8s.io/v1',
                },
                {
                  value: 'ValidatingWebhookConfiguration',
                },
                {
                  value: 'cert-manager-webhook',
                },
              ],
              [
                {
                  value: 'apps/v1',
                },
                {
                  value: 'Deployment',
                },
                {
                  value: 'cert-manager',
                },
              ],
              [
                {
                  value: 'apps/v1',
                },
                {
                  value: 'Deployment',
                },
                {
                  value: 'cert-manager-cainjector',
                },
              ],
              [
                {
                  value: 'apps/v1',
                },
                {
                  value: 'Deployment',
                },
                {
                  value: 'cert-manager-webhook',
                },
              ],
              [
                {
                  value: 'rbac.authorization.k8s.io/v1',
                },
                {
                  value: 'ClusterRole',
                },
                {
                  value: 'cert-manager-cainjector',
                },
              ],
              [
                {
                  value: 'rbac.authorization.k8s.io/v1',
                },
                {
                  value: 'ClusterRole',
                },
                {
                  value: 'cert-manager-cluster-view',
                },
              ],
              [
                {
                  value: 'rbac.authorization.k8s.io/v1',
                },
                {
                  value: 'ClusterRole',
                },
                {
                  value: 'cert-manager-controller-approve:cert-manager-io',
                },
              ],
              [
                {
                  value: 'rbac.authorization.k8s.io/v1',
                },
                {
                  value: 'ClusterRole',
                },
                {
                  value: 'cert-manager-controller-certificates',
                },
              ],
              [
                {
                  value: 'rbac.authorization.k8s.io/v1',
                },
                {
                  value: 'ClusterRole',
                },
                {
                  value: 'cert-manager-controller-certificatesigningrequests',
                },
              ],
              [
                {
                  value: 'rbac.authorization.k8s.io/v1',
                },
                {
                  value: 'ClusterRole',
                },
                {
                  value: 'cert-manager-controller-challenges',
                },
              ],
              [
                {
                  value: 'rbac.authorization.k8s.io/v1',
                },
                {
                  value: 'ClusterRole',
                },
                {
                  value: 'cert-manager-controller-clusterissuers',
                },
              ],
              [
                {
                  value: 'rbac.authorization.k8s.io/v1',
                },
                {
                  value: 'ClusterRole',
                },
                {
                  value: 'cert-manager-controller-ingress-shim',
                },
              ],
              [
                {
                  value: 'rbac.authorization.k8s.io/v1',
                },
                {
                  value: 'ClusterRole',
                },
                {
                  value: 'cert-manager-controller-issuers',
                },
              ],
              [
                {
                  value: 'rbac.authorization.k8s.io/v1',
                },
                {
                  value: 'ClusterRole',
                },
                {
                  value: 'cert-manager-controller-orders',
                },
              ],
              [
                {
                  value: 'rbac.authorization.k8s.io/v1',
                },
                {
                  value: 'ClusterRole',
                },
                {
                  value: 'cert-manager-edit',
                },
              ],
              [
                {
                  value: 'rbac.authorization.k8s.io/v1',
                },
                {
                  value: 'ClusterRole',
                },
                {
                  value: 'cert-manager-view',
                },
              ],
              [
                {
                  value: 'rbac.authorization.k8s.io/v1',
                },
                {
                  value: 'ClusterRole',
                },
                {
                  value: 'cert-manager-webhook:subjectaccessreviews',
                },
              ],
              [
                {
                  value: 'rbac.authorization.k8s.io/v1',
                },
                {
                  value: 'ClusterRoleBinding',
                },
                {
                  value: 'cert-manager-cainjector',
                },
              ],
              [
                {
                  value: 'rbac.authorization.k8s.io/v1',
                },
                {
                  value: 'ClusterRoleBinding',
                },
                {
                  value: 'cert-manager-controller-approve:cert-manager-io',
                },
              ],
              [
                {
                  value: 'rbac.authorization.k8s.io/v1',
                },
                {
                  value: 'ClusterRoleBinding',
                },
                {
                  value: 'cert-manager-controller-certificates',
                },
              ],
              [
                {
                  value: 'rbac.authorization.k8s.io/v1',
                },
                {
                  value: 'ClusterRoleBinding',
                },
                {
                  value: 'cert-manager-controller-certificatesigningrequests',
                },
              ],
              [
                {
                  value: 'rbac.authorization.k8s.io/v1',
                },
                {
                  value: 'ClusterRoleBinding',
                },
                {
                  value: 'cert-manager-controller-challenges',
                },
              ],
              [
                {
                  value: 'rbac.authorization.k8s.io/v1',
                },
                {
                  value: 'ClusterRoleBinding',
                },
                {
                  value: 'cert-manager-controller-clusterissuers',
                },
              ],
              [
                {
                  value: 'rbac.authorization.k8s.io/v1',
                },
                {
                  value: 'ClusterRoleBinding',
                },
                {
                  value: 'cert-manager-controller-ingress-shim',
                },
              ],
              [
                {
                  value: 'rbac.authorization.k8s.io/v1',
                },
                {
                  value: 'ClusterRoleBinding',
                },
                {
                  value: 'cert-manager-controller-issuers',
                },
              ],
              [
                {
                  value: 'rbac.authorization.k8s.io/v1',
                },
                {
                  value: 'ClusterRoleBinding',
                },
                {
                  value: 'cert-manager-controller-orders',
                },
              ],
              [
                {
                  value: 'rbac.authorization.k8s.io/v1',
                },
                {
                  value: 'ClusterRoleBinding',
                },
                {
                  value: 'cert-manager-webhook:subjectaccessreviews',
                },
              ],
              [
                {
                  value: 'rbac.authorization.k8s.io/v1',
                },
                {
                  value: 'Role',
                },
                {
                  value: 'cert-manager-cainjector:leaderelection',
                },
              ],
              [
                {
                  value: 'rbac.authorization.k8s.io/v1',
                },
                {
                  value: 'Role',
                },
                {
                  value: 'cert-manager-tokenrequest',
                },
              ],
              [
                {
                  value: 'rbac.authorization.k8s.io/v1',
                },
                {
                  value: 'Role',
                },
                {
                  value: 'cert-manager-webhook:dynamic-serving',
                },
              ],
              [
                {
                  value: 'rbac.authorization.k8s.io/v1',
                },
                {
                  value: 'Role',
                },
                {
                  value: 'cert-manager:leaderelection',
                },
              ],
              [
                {
                  value: 'rbac.authorization.k8s.io/v1',
                },
                {
                  value: 'RoleBinding',
                },
                {
                  value: 'cert-manager-cainjector:leaderelection',
                },
              ],
              [
                {
                  value: 'rbac.authorization.k8s.io/v1',
                },
                {
                  value: 'RoleBinding',
                },
                {
                  value: 'cert-manager-webhook:dynamic-serving',
                },
              ],
              [
                {
                  value: 'rbac.authorization.k8s.io/v1',
                },
                {
                  value: 'RoleBinding',
                },
                {
                  value: 'cert-manager:leaderelection',
                },
              ],
              [
                {
                  value: 'v1',
                },
                {
                  value: 'Service',
                },
                {
                  value: 'cert-manager',
                },
              ],
              [
                {
                  value: 'v1',
                },
                {
                  value: 'Service',
                },
                {
                  value: 'cert-manager-cainjector',
                },
              ],
              [
                {
                  value: 'v1',
                },
                {
                  value: 'Service',
                },
                {
                  value: 'cert-manager-webhook',
                },
              ],
              [
                {
                  value: 'v1',
                },
                {
                  value: 'ServiceAccount',
                },
                {
                  value: 'cert-manager',
                },
              ],
              [
                {
                  value: 'v1',
                },
                {
                  value: 'ServiceAccount',
                },
                {
                  value: 'cert-manager-cainjector',
                },
              ],
              [
                {
                  value: 'v1',
                },
                {
                  value: 'ServiceAccount',
                },
                {
                  value: 'cert-manager-webhook',
                },
              ],
            ],
            type: 'table',
          },
          {
            style: 'markdown',
            text: '\n\n## Unchanged\n\nThere are no unchanged resources.\n\n# CRDs Diff\n\n## Deletions\n\nThere are no deletions to the CRDs.\n\n## Additions\n\nThere are no additions to the CRDs.\n\n## Changes\n\nThe following CRDs are changed:\n\n',
            type: 'text',
          },
          {
            description: '- certificaterequests.cert-manager.io',
            entries: [
              {
                style: 'markdown',
                text: '\n\nThe following resources are affected by the changes to the CRD:\n',
                type: 'text',
              },
              {
                column_definitions: [
                  { title: 'API Version' },
                  { title: 'Kind' },
                  { title: 'Name' },
                ],
                data: [
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'CertificateRequest' },
                    {
                      value: 'example-resource-01',
                    },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'CertificateRequest' },
                    { value: 'example-resource-02' },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'CertificateRequest' },
                    {
                      value: 'example-resource-03',
                    },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'CertificateRequest' },
                    {
                      value: 'example-resource-04',
                    },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'CertificateRequest' },
                    { value: 'example-resource-05' },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'CertificateRequest' },
                    { value: 'example-resource-06' },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'CertificateRequest' },
                    {
                      value: 'example-resource-07',
                    },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'CertificateRequest' },
                    { value: 'example-resource-08' },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'CertificateRequest' },
                    { value: 'example-resource-09' },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'CertificateRequest' },
                    {
                      value: 'example-resource-10',
                    },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'CertificateRequest' },
                    { value: 'example-resource-11' },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'CertificateRequest' },
                    {
                      value: 'example-resource-12',
                    },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'CertificateRequest' },
                    { value: 'example-resource-13' },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'CertificateRequest' },
                    { value: 'example-resource-14' },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'CertificateRequest' },
                    {
                      value: 'example-resource-15',
                    },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'CertificateRequest' },
                    { value: 'example-resource-16' },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'CertificateRequest' },
                    {
                      value: 'example-resource-17',
                    },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'CertificateRequest' },
                    {
                      value: 'example-resource-18',
                    },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'CertificateRequest' },
                    { value: 'example-resource-19' },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'CertificateRequest' },
                    {
                      value: 'example-resource-20',
                    },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'CertificateRequest' },
                    { value: 'example-resource-21' },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'CertificateRequest' },
                    {
                      value: 'example-resource-22',
                    },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'CertificateRequest' },
                    {
                      value: 'example-resource-23',
                    },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'CertificateRequest' },
                    { value: 'example-resource-24' },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'CertificateRequest' },
                    { value: 'example-resource-25' },
                  ],
                ],
                type: 'table',
              },
              {
                style: 'markdown',
                text: '... and 36 more resources...\n',
                type: 'text',
              },
            ],
            title: '',
            type: 'accordion-underline',
          },
          {
            description: '- certificates.cert-manager.io',
            entries: [
              {
                style: 'markdown',
                text: '\n\nThe following resources are affected by the changes to the CRD:\n',
                type: 'text',
              },
              {
                column_definitions: [
                  { title: 'API Version' },
                  { title: 'Kind' },
                  { title: 'Name' },
                ],
                data: [
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'Certificate' },
                    {
                      value: 'example-resource-01',
                    },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'Certificate' },
                    {
                      value: 'example-resource-02',
                    },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'Certificate' },
                    {
                      value: 'example-resource-03',
                    },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'Certificate' },
                    {
                      value: 'example-resource-04',
                    },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'Certificate' },
                    {
                      value: 'example-resource-05',
                    },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'Certificate' },
                    {
                      value: 'example-resource-06',
                    },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'Certificate' },
                    { value: 'example-resource-07' },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'Certificate' },
                    {
                      value: 'example-resource-08',
                    },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'Certificate' },
                    {
                      value: 'example-resource-09',
                    },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'Certificate' },
                    {
                      value: 'example-resource-10',
                    },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'Certificate' },
                    {
                      value: 'example-resource-11',
                    },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'Certificate' },
                    { value: 'example-resource-12' },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'Certificate' },
                    { value: 'example-resource-13' },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'Certificate' },
                    { value: 'example-resource-14' },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'Certificate' },
                    {
                      value: 'example-resource-15',
                    },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'Certificate' },
                    {
                      value: 'example-resource-16',
                    },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'Certificate' },
                    { value: 'example-resource-17' },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'Certificate' },
                    { value: 'example-resource-18' },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'Certificate' },
                    {
                      value: 'example-resource-19',
                    },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'Certificate' },
                    { value: 'example-resource-20' },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'Certificate' },
                    {
                      value: 'example-resource-21',
                    },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'Certificate' },
                    { value: 'example-resource-22' },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'Certificate' },
                    {
                      value: 'example-resource-23',
                    },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'Certificate' },
                    {
                      value: 'example-resource-24',
                    },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'Certificate' },
                    { value: 'example-resource-25' },
                  ],
                ],
                type: 'table',
              },
              {
                style: 'markdown',
                text: '... and 571 more resources...\n',
                type: 'text',
              },
            ],
            title: '',
            type: 'accordion-underline',
          },
          {
            description: '- challenges.acme.cert-manager.io',
            entries: [
              {
                style: 'markdown',
                text: '\n\nThe following resources are affected by the changes to the CRD:\n',
                type: 'text',
              },
              {
                column_definitions: [
                  { title: 'API Version' },
                  { title: 'Kind' },
                  { title: 'Name' },
                ],
                data: [
                  [
                    { value: 'acme.cert-manager.io/v1' },
                    { value: 'Challenge' },
                    {
                      value: 'example-resource-01',
                    },
                  ],
                  [
                    { value: 'acme.cert-manager.io/v1' },
                    { value: 'Challenge' },
                    {
                      value: 'example-resource-02',
                    },
                  ],
                  [
                    { value: 'acme.cert-manager.io/v1' },
                    { value: 'Challenge' },
                    {
                      value: 'example-resource-03',
                    },
                  ],
                  [
                    { value: 'acme.cert-manager.io/v1' },
                    { value: 'Challenge' },
                    {
                      value: 'example-resource-04',
                    },
                  ],
                ],
                type: 'table',
              },
            ],
            title: '',
            type: 'accordion-underline',
          },
          {
            description: '- clusterissuers.cert-manager.io',
            entries: [
              {
                style: 'markdown',
                text: '\n\nThe following resources are affected by the changes to the CRD:\n',
                type: 'text',
              },
              {
                column_definitions: [
                  { title: 'API Version' },
                  { title: 'Kind' },
                  { title: 'Name' },
                ],
                data: [
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'ClusterIssuer' },
                    { value: 'example-resource-01' },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'ClusterIssuer' },
                    { value: 'example-resource-02' },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'ClusterIssuer' },
                    { value: 'example-resource-03' },
                  ],
                ],
                type: 'table',
              },
            ],
            title: '',
            type: 'accordion-underline',
          },
          {
            description: '- issuers.cert-manager.io',
            entries: [
              {
                style: 'markdown',
                text: '\n\nThe following resources are affected by the changes to the CRD:\n',
                type: 'text',
              },
              {
                column_definitions: [
                  { title: 'API Version' },
                  { title: 'Kind' },
                  { title: 'Name' },
                ],
                data: [
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'Issuer' },
                    { value: 'example-resource-01' },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'Issuer' },
                    { value: 'example-resource-02' },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'Issuer' },
                    { value: 'example-resource-03' },
                  ],
                  [
                    { value: 'cert-manager.io/v1' },
                    { value: 'Issuer' },
                    { value: 'example-resource-04' },
                  ],
                ],
                type: 'table',
              },
            ],
            title: '',
            type: 'accordion-underline',
          },
          {
            description: '- orders.acme.cert-manager.io',
            entries: [
              {
                style: 'markdown',
                text: '\n\nThe following resources are affected by the changes to the CRD:\n',
                type: 'text',
              },
              {
                column_definitions: [
                  { title: 'API Version' },
                  { title: 'Kind' },
                  { title: 'Name' },
                ],
                data: [
                  [
                    { value: 'acme.cert-manager.io/v1' },
                    { value: 'Order' },
                    {
                      value: 'example-resource-01',
                    },
                  ],
                  [
                    { value: 'acme.cert-manager.io/v1' },
                    { value: 'Order' },
                    {
                      value: 'example-resource-02',
                    },
                  ],
                  [
                    { value: 'acme.cert-manager.io/v1' },
                    { value: 'Order' },
                    {
                      value: 'example-resource-03',
                    },
                  ],
                  [
                    { value: 'acme.cert-manager.io/v1' },
                    { value: 'Order' },
                    {
                      value: 'example-resource-04',
                    },
                  ],
                  [
                    { value: 'acme.cert-manager.io/v1' },
                    { value: 'Order' },
                    {
                      value: 'example-resource-05',
                    },
                  ],
                  [
                    { value: 'acme.cert-manager.io/v1' },
                    { value: 'Order' },
                    {
                      value: 'example-resource-06',
                    },
                  ],
                  [
                    { value: 'acme.cert-manager.io/v1' },
                    { value: 'Order' },
                    {
                      value: 'example-resource-07',
                    },
                  ],
                  [
                    { value: 'acme.cert-manager.io/v1' },
                    { value: 'Order' },
                    {
                      value: 'example-resource-08',
                    },
                  ],
                  [
                    { value: 'acme.cert-manager.io/v1' },
                    { value: 'Order' },
                    {
                      value: 'example-resource-09',
                    },
                  ],
                  [
                    { value: 'acme.cert-manager.io/v1' },
                    { value: 'Order' },
                    {
                      value: 'example-resource-10',
                    },
                  ],
                  [
                    { value: 'acme.cert-manager.io/v1' },
                    { value: 'Order' },
                    {
                      value: 'example-resource-11',
                    },
                  ],
                  [
                    { value: 'acme.cert-manager.io/v1' },
                    { value: 'Order' },
                    {
                      value: 'example-resource-12',
                    },
                  ],
                  [
                    { value: 'acme.cert-manager.io/v1' },
                    { value: 'Order' },
                    {
                      value: 'example-resource-13',
                    },
                  ],
                  [
                    { value: 'acme.cert-manager.io/v1' },
                    { value: 'Order' },
                    {
                      value: 'example-resource-14',
                    },
                  ],
                  [
                    { value: 'acme.cert-manager.io/v1' },
                    { value: 'Order' },
                    {
                      value: 'example-resource-15',
                    },
                  ],
                  [
                    { value: 'acme.cert-manager.io/v1' },
                    { value: 'Order' },
                    {
                      value: 'example-resource-16',
                    },
                  ],
                  [
                    { value: 'acme.cert-manager.io/v1' },
                    { value: 'Order' },
                    {
                      value: 'example-resource-17',
                    },
                  ],
                  [
                    { value: 'acme.cert-manager.io/v1' },
                    { value: 'Order' },
                    {
                      value: 'example-resource-18',
                    },
                  ],
                  [
                    { value: 'acme.cert-manager.io/v1' },
                    { value: 'Order' },
                    {
                      value: 'example-resource-19',
                    },
                  ],
                  [
                    { value: 'acme.cert-manager.io/v1' },
                    { value: 'Order' },
                    {
                      value: 'example-resource-20',
                    },
                  ],
                  [
                    { value: 'acme.cert-manager.io/v1' },
                    { value: 'Order' },
                    {
                      value: 'example-resource-21',
                    },
                  ],
                  [
                    { value: 'acme.cert-manager.io/v1' },
                    { value: 'Order' },
                    {
                      value: 'example-resource-22',
                    },
                  ],
                  [
                    { value: 'acme.cert-manager.io/v1' },
                    { value: 'Order' },
                    {
                      value: 'example-resource-23',
                    },
                  ],
                  [
                    { value: 'acme.cert-manager.io/v1' },
                    { value: 'Order' },
                    {
                      value: 'example-resource-24',
                    },
                  ],
                  [
                    { value: 'acme.cert-manager.io/v1' },
                    { value: 'Order' },
                    {
                      value: 'example-resource-25',
                    },
                  ],
                ],
                type: 'table',
              },
              {
                style: 'markdown',
                text: '... and 5355 more resources...\n',
                type: 'text',
              },
            ],
            title: '',
            type: 'accordion-underline',
          },
          {
            style: 'markdown',
            text: '\n\n\n\n## Unchanged\n\nThere are no unchanged CRDs.\n\n\n',
            type: 'text',
          },
        ],
        created: 0,
        updated: 0,
      },
      {
        step_number: 3,
        comments: {},
        name: 'Generate Pull Request',
        owner: 'chkk',
        status: 'in-progress',
        allowed_action_types: [
          'skip',
          'undo-skip',
          'mark-completed',
          'undo-mark-completed',
          'open-lcm-agent',
        ],
        content_blocks: [
          {
            style: 'markdown',
            text: '\n**Open IaC Pull Request with AI**\n\nClick Actions → Agent Actions → Open IaC Pull Request with AI\n\n\n**Open IaC Pull Request Manually**\n\nApply the required changes to your IaC and open a Pull Request for review.\n\n* Create a feature branch from the base branch (for example: `upgrade/cert-manager-1.19.1`).\n* Apply edits guided by the changes above\n* Commit with clear messages (what changed, why, links to diffs), then push and open a Pull Request.\n\n',
            type: 'text',
          },
        ],
        created: 0,
        updated: 0,
      },
      {
        step_number: 4,
        comments: {},
        name: 'Review & Merge Pull Request',
        owner: 'chkk',
        status: 'in-progress',
        allowed_action_types: [
          'skip',
          'undo-skip',
          'mark-completed',
          'undo-mark-completed',
        ],
        content_blocks: [
          {
            style: 'markdown',
            text: 'Have the repository owners review and approve the Pull Request. Ensure required checks pass before merging.\n\n**Reviewer guidance**\n\n- Confirm package coordinates and target versions are correct.\n- Validate diffs (values and manifests) match the intended change scope.\n- Check for CRD changes if applicable.\n- Ensure tests/validation steps are described and feasible in the target environments.\n\n',
            type: 'text',
          },
        ],
        created: 0,
        updated: 0,
      },
    ],
    updated: 0,
  },
  {
    allowed_action_types: [],
    created: 0,
    name: 'Preflight Checks',
    stage_number: 5,
    status: 'in-progress',
    steps: [
      {
        step_number: 1,
        comments: {},
        name: 'Prerequisites',
        owner: 'chkk',
        status: 'in-progress',
        allowed_action_types: [
          'skip',
          'undo-skip',
          'mark-completed',
          'undo-mark-completed',
        ],
        content_blocks: [
          {
            style: 'markdown',
            text: '\n\n\n- [kubectl](https://kubernetes.io/docs/tasks/tools/#kubectl): The Kubernetes command-line tool, kubectl, must be installed and configured to communicate with your Kubernetes cluster.\n- [cert-manager CLI (cmctl)](https://cert-manager.io/docs/reference/cmctl/): This tool is essential for several checks. Starting with cert-manager v1.14.0, cmctl moved to a separate repository with independent versioning. For cert-manager versions later than v1.14.x, you must use cmctl v2.x (v2.0.0 or newer). Install cmctl from the [standalone cmctl releases page](https://github.com/cert-manager/cmctl/releases). Run `cmctl version` to ensure cmctl v2.x or later is in use. [Learn more about cmctl](https://cert-manager.io/docs/reference/cmctl/)\n- [openssl](https://openssl-library.org/source/): A widely used TLS/SSL and cryptography toolkit. Use it to generate private keys and CSRs, convert certificate formats (PEM, DER, PKCS#12), and inspect or verify certificates and chains.\n- [chkk CLI](https://docs.chkk.io/product/chkkcli/overview): The Chkk CLI allows you to run the checks automatically instead of copying the commands by hand.\n\n',
            type: 'text',
          },
        ],
        created: 0,
        updated: 0,
      },
      {
        step_number: 2,
        comments: {},
        name: 'Resource Health Checks',
        owner: 'chkk',
        status: 'in-progress',
        allowed_action_types: [
          'skip',
          'undo-skip',
          'mark-completed',
          'undo-mark-completed',
        ],
        content_blocks: [
          {
            style: 'markdown',
            text: '\n### Execute Automatically\n\nRun the following command in your terminal with the Chkk CLI configured to perform Safety, Health and Readiness Checks (SHARC):\n\n```\nchkk sharc run --local --verbose -f "type:resource.health version:1.16.0" --vars namespace=cert-manager cert-manager\n```\n\n\n### Execute Manually\n\nAlternatively, ensure that all critical cert-manager components are operational and healthy:\n\n```\nexport CM_NAMESPACE=cert-manager\nkubectl --namespace $CM_NAMESPACE get deployment\n```\n\nSample Output:\n\n```\nNAME                      READY   UP-TO-DATE   AVAILABLE   AGE\ncert-manager              1/1     1            1           13d\ncert-manager-cainjector   1/1     1            1           13d\ncert-manager-webhook      1/1     1            1           13d\n```\n\n\n\nVerify webhook configuration is properly set up:\n\n```\nkubectl --namespace $CM_NAMESPACE get validatingwebhookconfigurations cert-manager-webhook\nkubectl --namespace $CM_NAMESPACE get mutatingwebhookconfigurations cert-manager-webhook\n```\n\nSample Output:\n\n```\nNAME                   WEBHOOKS   AGE\ncert-manager-webhook   1          5h6m\nNAME                   WEBHOOKS   AGE\ncert-manager-webhook   1          5h6m\n```\n\n\n',
            type: 'text',
          },
        ],
        created: 0,
        updated: 0,
      },
      {
        step_number: 3,
        comments: {},
        name: 'API Readiness Checks',
        owner: 'chkk',
        status: 'in-progress',
        allowed_action_types: [
          'skip',
          'undo-skip',
          'mark-completed',
          'undo-mark-completed',
        ],
        content_blocks: [
          {
            style: 'markdown',
            text: "\n### Execute Automatically\n\nRun the following command in your terminal with the Chkk CLI configured to perform Safety, Health and Readiness Checks (SHARC):\n\n```\nchkk sharc run --local --verbose -f \"type:api.readiness version:1.16.0\" --vars namespace=cert-manager cert-manager\n```\n\n\n### Execute Manually\n\nAlternatively, verify that the cert-manager API is ready and responding correctly by using the cert-manager CLI and by probing the 'healthz' endpoint of the cert-manager-webhook Pod.\n\nUsing the CLI:\n\n```\ncmctl check api\n```\n\nSample Output:\n\n```\nThe cert-manager API is ready\n```\n\n\n\nRetrieve the current IP address of the cert-manager-webhook Pod:\n\n```\nexport CM_NAMESPACE=cert-manager\nexport CM_WEBHOOK_POD=<CERT_MANAGER_WEBHOOK_POD_NAME>\nkubectl get pod $CM_WEBHOOK_POD --namespace $CM_NAMESPACE -o jsonpath='{.status.podIP}'\n```\n\nSample Output:\n\n```\n10.244.0.44\n```\n\n\n\nStart a shell inside a test Pod:\n\n```\nkubectl run chkk-cert-manager-api-check --image=curlimages/curl -i --tty -- sh\n```\nAssign the cert-manager-webhook Pod's IP address to an environment variable inside the test Pod:\n\n```\nexport CM_IP=<CERT_MANAGER_POD_IP>\n```\nRetrieve cert-manager-webhook Pod health:\n\n```\ncurl -v http://$CM_IP:6080/healthz\n```\n\nSample Output:\n\n```\n*   Trying 10.244.0.44:6080...\n* Connected to 10.244.0.44 (10.244.0.44) port 6080\n> GET /healthz HTTP/1.1\n> Host: 10.244.0.44:6080\n> User-Agent: curl/8.8.0\n> Accept: */*\n>\n* Request completely sent off\n< HTTP/1.1 200 OK\n< Date: Wed, 12 Jun 2024 11:13:22 GMT\n< Content-Length: 0\n<\n* Connection #0 to host 10.244.0.44 left intact\n```\n\n\n\nExit the test Pod:\n\n```\nexit\n```\nClean up the test Pod:\n\n```\nkubectl delete pod chkk-cert-manager-api-check\n```\n\n",
            type: 'text',
          },
        ],
        created: 0,
        updated: 0,
      },
      {
        step_number: 4,
        comments: {},
        name: 'End-to-End Verification Checks',
        owner: 'chkk',
        status: 'in-progress',
        allowed_action_types: [
          'skip',
          'undo-skip',
          'mark-completed',
          'undo-mark-completed',
        ],
        content_blocks: [
          {
            style: 'markdown',
            text: '\n### Execute Automatically\n\nRun the following command in your terminal with the Chkk CLI configured to perform Safety, Health and Readiness Checks (SHARC):\n\n```\nchkk sharc run --local --verbose -f "type:e2e.verification version:1.16.0" --vars namespace=cert-manager cert-manager\n```\n\n\n### Execute Manually\n\nAlternatively, verify cert-manager\'s complete functionality by testing the full certificate lifecycle including issuance, validation, and renewal processes.\n\nStep 1: Create Test Resources\n\nCreate a test namespace, self-signed issuer, and certificate resource:\n\n```\nkubectl apply -f - <<EOF\napiVersion: v1\nkind: Namespace\nmetadata:\n  name: chkk-test-cert-manager\n---\napiVersion: cert-manager.io/v1\nkind: Issuer\nmetadata:\n  name: test-selfsigned\n  namespace: chkk-test-cert-manager\nspec:\n  selfSigned: {}\n---\napiVersion: cert-manager.io/v1\nkind: Certificate\nmetadata:\n  name: selfsigned-cert\n  namespace: chkk-test-cert-manager\nspec:\n  dnsNames:\n    - example.com\n  secretname: selfsigned-cert-tls\n  issuerRef:\n    name: test-selfsigned\n    kind: Issuer\n    group: cert-manager.io\nEOF\n```\nStep 2: Verify Issuer Health\n\nConfirm that the self-signed issuer is ready and functional:\n\n```\nkubectl --namespace chkk-test-cert-manager get issuer test-selfsigned\n```\n\nSample Output:\n\n```\nNAME              READY   AGE\ntest-selfsigned   True    76m\n```\n\n\n\nStep 3: Verify Certificate Issuance\n\nConfirm that cert-manager successfully issued the certificate and verify all certificate details are correct:\n\n```\nkubectl describe certificate selfsigned-cert --namespace chkk-test-cert-manager\n```\n\nSample Output:\n\n```\n...\nSpec:\n  Dns Names:\n    example.com\n  Issuer Ref:\n    Group:      cert-manager.io\n    Kind:       Issuer\n    Name:       test-selfsigned\n  Secret Name:  selfsigned-cert-tls\nstatus:\n  Conditions:\n    Last Transition Time:  2025-07-31T12:28:08Z\n    Message:               Certificate is up to date and has not expired\n    Observed Generation:   1\n    Reason:                Ready\n    Status:                True\n    Type:                  Ready\n  Not After:               2025-10-29T12:28:08Z\n  Not Before:              2025-07-31T12:28:08Z\n  Renewal Time:            2025-09-29T12:28:08Z\n  Revision:                1\nEvents:\n  Type    Reason     Age   From                                       Message\n  ----    ------     ----  ----                                       -------\n  Normal  Issuing    26s   cert-manager-certificates-trigger          Issuing certificate as Secret does not exist\n  Normal  Generated  26s   cert-manager-certificates-key-manager      Stored new private key in temporary Secret resource "selfsigned-cert-5v8hx"\n  Normal  Requested  26s   cert-manager-certificates-request-manager  Created new CertificateRequest resource "selfsigned-cert-1"\n  Normal  Issuing    26s   cert-manager-certificates-issuing          The certificate has been successfully issued\n```\n\n\n\nCheck Certificate status with cmctl:\n\n```\ncmctl status certificate selfsigned-cert --namespace chkk-test-cert-manager\n```\n\nSample Output:\n\n```\nName: selfsigned-cert\nNamespace: chkk-test-cert-manager\nCreated at: 2025-07-31T17:28:07+05:00\nConditions:\n  Ready: True, Reason: Ready, Message: Certificate is up to date and has not expired\nDNS Names:\n- example.com\nEvents:\n  Type    Reason     Age   From                                       Message\n  ----    ------     ----  ----                                       -------\n  Normal  Issuing    2m8s  cert-manager-certificates-trigger          Issuing certificate as Secret does not exist\n  Normal  Generated  2m8s  cert-manager-certificates-key-manager      Stored new private key in temporary Secret resource "selfsigned-cert-5v8hx"\n  Normal  Requested  2m8s  cert-manager-certificates-request-manager  Created new CertificateRequest resource "selfsigned-cert-1"\n  Normal  Issuing    2m8s  cert-manager-certificates-issuing          The certificate has been successfully issued\nIssuer:\n  Name: test-selfsigned\n  Kind: Issuer\n  Conditions:\n    Ready: True, Reason: IsReady, Message:\n  Events:  <none>\nSecret:\n  Name: selfsigned-cert-tls\n  Issuer Country:\n  Issuer Organisation:\n  Issuer Common Name:\n  Key Usage: Digital Signature, Key Encipherment\n  Extended Key Usages:\n  Public Key Algorithm: RSA\n  Signature Algorithm: SHA256-RSA\n  Subject Key ID:\n  Authority Key ID:\n  Serial Number: 628d662b87bbf01ddefa0ff079118cc4\n  Events:  <none>\nNot Before: 2025-07-31T17:28:08+05:00\nNot After: 2025-10-29T17:28:08+05:00\nRenewal Time: 2025-09-29T17:28:08+05:00\n```\n\n\n\nStep 4: Certificate Validity & Chain Verification\n\nExtract and validate the certificate to ensure it\'s properly formed and valid. This addresses certificate validity and chain validation requirements.\n\nExtract the leaf certificate from the Secret:\n\n```\nkubectl --namespace chkk-test-cert-manager \\\n  get secret selfsigned-cert-tls -o jsonpath=\'{.data.tls\\.crt}\' | base64 -d > leaf.crt\n```\nSet the trust bundle (for self-signed certificates, the leaf certificate serves as both the certificate and the CA):\n\n```\ncp leaf.crt ca-bundle.pem\n```\nValidate certificate expiration dates to ensure the certificate is not expired:\n\n```\nopenssl x509 -in leaf.crt -noout -dates\n```\n\nSample Output:\n\n```\nnotBefore=Jul 31 12:28:08 2025 GMT\nnotAfter=Oct 29 12:28:08 2025 GMT\n```\n\n\n\nPerform certificate chain verification to ensure the trust path is valid:\n\n```\nopenssl verify -CAfile ca-bundle.pem leaf.crt\n```\n\nSample Output:\n\n```\nleaf.crt: OK\n```\n\n\n\nStep 5: Certificate Content Validation\n\nValidate certificate contents including Subject Alternative Names (SANs) and verify that the private key matches the certificate.\n\nExtract the private key from the Secret:\n\n```\nkubectl --namespace chkk-test-cert-manager \\\n  get secret selfsigned-cert-tls -o jsonpath=\'{.data.tls\\.key}\' | base64 -d > leaf.key\n```\nList SANs on the certificate:\n\nInspect Subject Alternative Names to ensure correct DNS names are present:\n\n```\nopenssl x509 -in leaf.crt -noout -ext subjectAltName\n```\n\nSample Output:\n\n```\nX509v3 Subject Alternative Name: critical\n    DNS:example.com\n```\n\n\n\nVerify cryptographic pairing between private key and certificate by comparing modulus hashes:\n\n```\necho "Certificate modulus hash:"\nopenssl x509 -in leaf.crt -noout -modulus | openssl sha256\necho "Private key modulus hash:"\nopenssl rsa -in leaf.key -noout -modulus | openssl sha256\n```\n\nSample Output:\n\n```\nCertificate modulus hash:\nSHA2-256(stdin)= 110030f83fb5ceecc0db57f878d6a41bad338dd4977e0b188208476d8e5b89d3\nPrivate key modulus hash:\nSHA2-256(stdin)= 110030f83fb5ceecc0db57f878d6a41bad338dd4977e0b188208476d8e5b89d3\n```\n\n\n\nValidate Result: If the two hashes differ, the key and certificate do not belong to the same key pair — indicating a critical misconfiguration.\n\n_Note: In above test scenario, the hashes should always match since cert-manager generated both components. This check is more valuable when troubleshooting imported certificates or production issues._\n\nStep 6: Certificate Renewal Testing\n\nTest the certificate renewal functionality to ensure cert-manager can successfully handle certificate lifecycle management.\n\nManually trigger certificate renewal to test renewal controller functionality:\n\n```\ncmctl renew selfsigned-cert --namespace chkk-test-cert-manager\n```\n\nSample Output:\n\n```\nManually triggered issuance of Certificate chkk-test-cert-manager/selfsigned-cert\n```\n\n\n\nVerify the certificate remains in Ready state after renewal and check renewal events:\n\n```\ncmctl --namespace chkk-test-cert-manager status certificate selfsigned-cert\n```\n\nSample Output:\n\n```\nName: selfsigned-cert\nNamespace: chkk-test-cert-manager\nCreated at: 2025-07-31T17:28:07+05:00\nConditions:\n  Ready: True, Reason: Ready, Message: Certificate is up to date and has not expired\nDNS Names:\n- example.com\nEvents:\n  Type    Reason     Age               From                                       Message\n  ----    ------     ----              ----                                       -------\n  Normal  Issuing    10m               cert-manager-certificates-trigger          Issuing certificate as Secret does not exist\n  Normal  Generated  10m               cert-manager-certificates-key-manager      Stored new private key in temporary Secret resource "selfsigned-cert-5v8hx"\n  Normal  Requested  10m               cert-manager-certificates-request-manager  Created new CertificateRequest resource "selfsigned-cert-1"\n  Normal  Issuing    9s (x2 over 10m)  cert-manager-certificates-issuing          The certificate has been successfully issued\n  Normal  Generated  9s                cert-manager-certificates-key-manager      Stored new private key in temporary Secret resource "selfsigned-cert-xjvw8"\n  Normal  Requested  9s                cert-manager-certificates-request-manager  Created new CertificateRequest resource "selfsigned-cert-2"\nIssuer:\n  Name: test-selfsigned\n  Kind: Issuer\n  Conditions:\n    Ready: True, Reason: IsReady, Message:\n  Events:  <none>\nSecret:\n  Name: selfsigned-cert-tls\n  Issuer Country:\n  Issuer Organisation:\n  Issuer Common Name:\n  Key Usage: Digital Signature, Key Encipherment\n  Extended Key Usages:\n  Public Key Algorithm: RSA\n  Signature Algorithm: SHA256-RSA\n  Subject Key ID:\n  Authority Key ID:\n  Serial Number: 66a8aad292536674bae87df0b0738d3f\n  Events:  <none>\nNot Before: 2025-07-31T17:38:32+05:00\nNot After: 2025-10-29T17:38:32+05:00\nRenewal Time: 2025-09-29T17:38:32+05:00\n```\n\n\n\nConfirm that new CertificateRequest resources were created during the renewal process:\n\n```\nkubectl --namespace chkk-test-cert-manager get certificaterequests\n```\nSample Output (before renewal):\n\n```\nNAME                APPROVED   DENIED   READY   ISSUER            REQUESTER                                         AGE\nselfsigned-cert-1   True                True    test-selfsigned   system:serviceaccount:cert-manager:cert-manager   2m12s\n```\nSample Output (after renewal):\n\n```\nNAME                APPROVED   DENIED   READY   ISSUER            REQUESTER                                         AGE\nselfsigned-cert-2   True                True    test-selfsigned   system:serviceaccount:cert-manager:cert-manager   3m20s\n```\nStep 7: Cleanup Test Resources\n\nRemove all test resources and temporary files created during the verification process.\n\nRemove the test namespace and all associated resources:\n\n```\nkubectl delete namespace chkk-test-cert-manager\n```\nRemove temporary certificate files from the local filesystem:\n\n```\nrm -f leaf.crt leaf.key ca-bundle.pem\n```\n\n',
            type: 'text',
          },
        ],
        created: 0,
        updated: 0,
      },
    ],
    updated: 0,
  },
  {
    allowed_action_types: [],
    created: 0,
    name: 'Deploy',
    stage_number: 6,
    status: 'in-progress',
    steps: [
      {
        step_number: 1,
        comments: {},
        name: 'Select Deployment Targets',
        owner: 'chkk',
        status: 'in-progress',
        allowed_action_types: [
          'skip',
          'undo-skip',
          'mark-completed',
          'undo-mark-completed',
        ],
        content_blocks: [
          {
            style: 'markdown',
            text: '\n\nSelect the deployment targets for this rollout.\n\nEnvironment: `Dev`\nCluster: `aks-131-cus1-dev`\n\n',
            type: 'text',
          },
        ],
        created: 0,
        updated: 0,
      },
      {
        step_number: 2,
        comments: {},
        name: 'Create Release Tag',
        owner: 'chkk',
        status: 'in-progress',
        allowed_action_types: [
          'skip',
          'undo-skip',
          'mark-completed',
          'undo-mark-completed',
        ],
        content_blocks: [
          {
            style: 'markdown',
            text: 'Create a Git tag containing the merged pull requests for this upgrade. Record this tag so the deployment reconciles to it across the selected environment and cluster.\n\n',
            type: 'text',
          },
        ],
        created: 0,
        updated: 0,
      },
      {
        step_number: 3,
        comments: {},
        name: 'Apply CRDs First',
        owner: 'chkk',
        status: 'in-progress',
        allowed_action_types: [
          'skip',
          'undo-skip',
          'mark-completed',
          'undo-mark-completed',
        ],
        content_blocks: [
          {
            style: 'markdown',
            text: 'If this upgrade includes CRD changes, ensure CRDs are applied before controller and webhook updates for aks-131-cus1-dev.\n- GitOps: place CRDs in a pre-sync hook or ensure ordering that applies CRDs first.\n- Pipelines: include a pre-deploy stage to apply the CRD bundle for this release.\n\n',
            type: 'text',
          },
        ],
        created: 0,
        updated: 0,
      },
      {
        step_number: 4,
        comments: {},
        name: 'Start Deployment',
        owner: 'chkk',
        status: 'in-progress',
        allowed_action_types: [
          'skip',
          'undo-skip',
          'mark-completed',
          'undo-mark-completed',
        ],
        content_blocks: [
          {
            style: 'markdown',
            text: 'Deploy the release tag to `Dev`/`aks-131-cus1-dev` using your CD system.\n\n- GitOps (Argo CD or Flux):\n  - Ensure the application points to the release tag created in the previous step. If auto-sync is enabled, the system will reconcile automatically; otherwise, request a sync. Wait for the application to reach Healthy and Synced.\n\n- Pipeline-driven (Harness, Jenkins, GitHub Actions, etc.):\n  - Start the deploy job/workflow with inputs:\n  - Release tag, environment=`Dev`, cluster=`aks-131-cus1-dev`.\n  - Wait for the job to Succeed.\n\nOptional: Record the run link or application URL after you trigger the deployment as a Custom Step.\n\n',
            type: 'text',
          },
        ],
        created: 0,
        updated: 0,
      },
      {
        step_number: 5,
        comments: {},
        name: 'Watch for Healthy State',
        owner: 'chkk',
        status: 'in-progress',
        allowed_action_types: [
          'skip',
          'undo-skip',
          'mark-completed',
          'undo-mark-completed',
        ],
        content_blocks: [
          {
            style: 'markdown',
            text: 'Monitor the deployment until the system reaches a steady state.\n\nSuccess criteria (minimum):\n- Deployment systems reports the application as Healthy/Synced (GitOps) or the deploy job Succeeded (pipeline).\n- No sustained increase in admission failures during the initial convergence window.\n\n',
            type: 'text',
          },
        ],
        created: 0,
        updated: 0,
      },
    ],
    updated: 0,
  },
  {
    allowed_action_types: [],
    created: 0,
    name: 'Postflight Checks',
    stage_number: 7,
    status: 'in-progress',
    steps: [
      {
        step_number: 1,
        comments: {},
        name: 'Prerequisites',
        owner: 'chkk',
        status: 'in-progress',
        allowed_action_types: [
          'skip',
          'undo-skip',
          'mark-completed',
          'undo-mark-completed',
        ],
        content_blocks: [
          {
            style: 'markdown',
            text: '\n\n\n- [kubectl](https://kubernetes.io/docs/tasks/tools/#kubectl): The Kubernetes command-line tool, kubectl, must be installed and configured to communicate with your Kubernetes cluster.\n- [cert-manager CLI (cmctl)](https://cert-manager.io/docs/reference/cmctl/): This tool is essential for several checks. Starting with cert-manager v1.14.0, cmctl moved to a separate repository with independent versioning. For cert-manager versions later than v1.14.x, you must use cmctl v2.x (v2.0.0 or newer). Install cmctl from the [standalone cmctl releases page](https://github.com/cert-manager/cmctl/releases). Run `cmctl version` to ensure cmctl v2.x or later is in use. [Learn more about cmctl](https://cert-manager.io/docs/reference/cmctl/)\n- [openssl](https://openssl-library.org/source/): A widely used TLS/SSL and cryptography toolkit. Use it to generate private keys and CSRs, convert certificate formats (PEM, DER, PKCS#12), and inspect or verify certificates and chains.\n- [chkk CLI](https://docs.chkk.io/product/chkkcli/overview): The Chkk CLI allows you to run the checks automatically instead of copying the commands by hand.\n\n',
            type: 'text',
          },
        ],
        created: 0,
        updated: 0,
      },
      {
        step_number: 2,
        comments: {},
        name: 'Resource Health Checks',
        owner: 'chkk',
        status: 'in-progress',
        allowed_action_types: [
          'skip',
          'undo-skip',
          'mark-completed',
          'undo-mark-completed',
        ],
        content_blocks: [
          {
            style: 'markdown',
            text: '\n### Execute Automatically\n\nRun the following command in your terminal with the Chkk CLI configured to perform Safety, Health and Readiness Checks (SHARC):\n\n```\nchkk sharc run --local --verbose -f "type:resource.health version:1.19.1" --vars namespace=cert-manager cert-manager\n```\n\n\n### Execute Manually\n\nAlternatively, ensure that all critical cert-manager components are operational and healthy:\n\n```\nexport CM_NAMESPACE=cert-manager\nkubectl --namespace $CM_NAMESPACE get deployment\n```\n\nSample Output:\n\n```\nNAME                      READY   UP-TO-DATE   AVAILABLE   AGE\ncert-manager              1/1     1            1           13d\ncert-manager-cainjector   1/1     1            1           13d\ncert-manager-webhook      1/1     1            1           13d\n```\n\n\n\nVerify webhook configuration is properly set up:\n\n```\nkubectl --namespace $CM_NAMESPACE get validatingwebhookconfigurations cert-manager-webhook\nkubectl --namespace $CM_NAMESPACE get mutatingwebhookconfigurations cert-manager-webhook\n```\n\nSample Output:\n\n```\nNAME                   WEBHOOKS   AGE\ncert-manager-webhook   1          5h6m\nNAME                   WEBHOOKS   AGE\ncert-manager-webhook   1          5h6m\n```\n\n\n',
            type: 'text',
          },
        ],
        created: 0,
        updated: 0,
      },
      {
        step_number: 3,
        comments: {},
        name: 'API Readiness Checks',
        owner: 'chkk',
        status: 'in-progress',
        allowed_action_types: [
          'skip',
          'undo-skip',
          'mark-completed',
          'undo-mark-completed',
        ],
        content_blocks: [
          {
            style: 'markdown',
            text: "\n### Execute Automatically\n\nRun the following command in your terminal with the Chkk CLI configured to perform Safety, Health and Readiness Checks (SHARC):\n\n```\nchkk sharc run --local --verbose -f \"type:api.readiness version:1.19.1\" --vars namespace=cert-manager cert-manager\n```\n\n\n### Execute Manually\n\nAlternatively, verify that the cert-manager API is ready and responding correctly by using the cert-manager CLI and by probing the 'healthz' endpoint of the cert-manager-webhook Pod.\n\nUsing the CLI:\n\n```\ncmctl check api\n```\n\nSample Output:\n\n```\nThe cert-manager API is ready\n```\n\n\n\nRetrieve the current IP address of the cert-manager-webhook Pod:\n\n```\nexport CM_NAMESPACE=cert-manager\nexport CM_WEBHOOK_POD=<CERT_MANAGER_WEBHOOK_POD_NAME>\nkubectl get pod $CM_WEBHOOK_POD --namespace $CM_NAMESPACE -o jsonpath='{.status.podIP}'\n```\n\nSample Output:\n\n```\n10.244.0.44\n```\n\n\n\nStart a shell inside a test Pod:\n\n```\nkubectl run chkk-cert-manager-api-check --image=curlimages/curl -i --tty -- sh\n```\nAssign the cert-manager-webhook Pod's IP address to an environment variable inside the test Pod:\n\n```\nexport CM_IP=<CERT_MANAGER_POD_IP>\n```\nRetrieve cert-manager-webhook Pod health:\n\n```\ncurl -v http://$CM_IP:6080/healthz\n```\n\nSample Output:\n\n```\n*   Trying 10.244.0.44:6080...\n* Connected to 10.244.0.44 (10.244.0.44) port 6080\n> GET /healthz HTTP/1.1\n> Host: 10.244.0.44:6080\n> User-Agent: curl/8.8.0\n> Accept: */*\n>\n* Request completely sent off\n< HTTP/1.1 200 OK\n< Date: Wed, 12 Jun 2024 11:13:22 GMT\n< Content-Length: 0\n<\n* Connection #0 to host 10.244.0.44 left intact\n```\n\n\n\nExit the test Pod:\n\n```\nexit\n```\nClean up the test Pod:\n\n```\nkubectl delete pod chkk-cert-manager-api-check\n```\n\n",
            type: 'text',
          },
        ],
        created: 0,
        updated: 0,
      },
      {
        step_number: 4,
        comments: {},
        name: 'End-to-End Verification Checks',
        owner: 'chkk',
        status: 'in-progress',
        allowed_action_types: [
          'skip',
          'undo-skip',
          'mark-completed',
          'undo-mark-completed',
        ],
        content_blocks: [
          {
            style: 'markdown',
            text: '\n### Execute Automatically\n\nRun the following command in your terminal with the Chkk CLI configured to perform Safety, Health and Readiness Checks (SHARC):\n\n```\nchkk sharc run --local --verbose -f "type:e2e.verification version:1.19.1" --vars namespace=cert-manager cert-manager\n```\n\n\n### Execute Manually\n\nAlternatively, verify cert-manager\'s complete functionality by testing the full certificate lifecycle including issuance, validation, and renewal processes.\n\nStep 1: Create Test Resources\n\nCreate a test namespace, self-signed issuer, and certificate resource:\n\n```\nkubectl apply -f - <<EOF\napiVersion: v1\nkind: Namespace\nmetadata:\n  name: chkk-test-cert-manager\n---\napiVersion: cert-manager.io/v1\nkind: Issuer\nmetadata:\n  name: test-selfsigned\n  namespace: chkk-test-cert-manager\nspec:\n  selfSigned: {}\n---\napiVersion: cert-manager.io/v1\nkind: Certificate\nmetadata:\n  name: selfsigned-cert\n  namespace: chkk-test-cert-manager\nspec:\n  dnsNames:\n    - example.com\n  secretname: selfsigned-cert-tls\n  issuerRef:\n    name: test-selfsigned\n    kind: Issuer\n    group: cert-manager.io\nEOF\n```\nStep 2: Verify Issuer Health\n\nConfirm that the self-signed issuer is ready and functional:\n\n```\nkubectl --namespace chkk-test-cert-manager get issuer test-selfsigned\n```\n\nSample Output:\n\n```\nNAME              READY   AGE\ntest-selfsigned   True    76m\n```\n\n\n\nStep 3: Verify Certificate Issuance\n\nConfirm that cert-manager successfully issued the certificate and verify all certificate details are correct:\n\n```\nkubectl describe certificate selfsigned-cert --namespace chkk-test-cert-manager\n```\n\nSample Output:\n\n```\n...\nSpec:\n  Dns Names:\n    example.com\n  Issuer Ref:\n    Group:      cert-manager.io\n    Kind:       Issuer\n    Name:       test-selfsigned\n  Secret Name:  selfsigned-cert-tls\nstatus:\n  Conditions:\n    Last Transition Time:  2025-07-31T12:28:08Z\n    Message:               Certificate is up to date and has not expired\n    Observed Generation:   1\n    Reason:                Ready\n    Status:                True\n    Type:                  Ready\n  Not After:               2025-10-29T12:28:08Z\n  Not Before:              2025-07-31T12:28:08Z\n  Renewal Time:            2025-09-29T12:28:08Z\n  Revision:                1\nEvents:\n  Type    Reason     Age   From                                       Message\n  ----    ------     ----  ----                                       -------\n  Normal  Issuing    26s   cert-manager-certificates-trigger          Issuing certificate as Secret does not exist\n  Normal  Generated  26s   cert-manager-certificates-key-manager      Stored new private key in temporary Secret resource "selfsigned-cert-5v8hx"\n  Normal  Requested  26s   cert-manager-certificates-request-manager  Created new CertificateRequest resource "selfsigned-cert-1"\n  Normal  Issuing    26s   cert-manager-certificates-issuing          The certificate has been successfully issued\n```\n\n\n\nCheck Certificate status with cmctl:\n\n```\ncmctl status certificate selfsigned-cert --namespace chkk-test-cert-manager\n```\n\nSample Output:\n\n```\nName: selfsigned-cert\nNamespace: chkk-test-cert-manager\nCreated at: 2025-07-31T17:28:07+05:00\nConditions:\n  Ready: True, Reason: Ready, Message: Certificate is up to date and has not expired\nDNS Names:\n- example.com\nEvents:\n  Type    Reason     Age   From                                       Message\n  ----    ------     ----  ----                                       -------\n  Normal  Issuing    2m8s  cert-manager-certificates-trigger          Issuing certificate as Secret does not exist\n  Normal  Generated  2m8s  cert-manager-certificates-key-manager      Stored new private key in temporary Secret resource "selfsigned-cert-5v8hx"\n  Normal  Requested  2m8s  cert-manager-certificates-request-manager  Created new CertificateRequest resource "selfsigned-cert-1"\n  Normal  Issuing    2m8s  cert-manager-certificates-issuing          The certificate has been successfully issued\nIssuer:\n  Name: test-selfsigned\n  Kind: Issuer\n  Conditions:\n    Ready: True, Reason: IsReady, Message:\n  Events:  <none>\nSecret:\n  Name: selfsigned-cert-tls\n  Issuer Country:\n  Issuer Organisation:\n  Issuer Common Name:\n  Key Usage: Digital Signature, Key Encipherment\n  Extended Key Usages:\n  Public Key Algorithm: RSA\n  Signature Algorithm: SHA256-RSA\n  Subject Key ID:\n  Authority Key ID:\n  Serial Number: 628d662b87bbf01ddefa0ff079118cc4\n  Events:  <none>\nNot Before: 2025-07-31T17:28:08+05:00\nNot After: 2025-10-29T17:28:08+05:00\nRenewal Time: 2025-09-29T17:28:08+05:00\n```\n\n\n\nStep 4: Certificate Validity & Chain Verification\n\nExtract and validate the certificate to ensure it\'s properly formed and valid. This addresses certificate validity and chain validation requirements.\n\nExtract the leaf certificate from the Secret:\n\n```\nkubectl --namespace chkk-test-cert-manager \\\n  get secret selfsigned-cert-tls -o jsonpath=\'{.data.tls\\.crt}\' | base64 -d > leaf.crt\n```\nSet the trust bundle (for self-signed certificates, the leaf certificate serves as both the certificate and the CA):\n\n```\ncp leaf.crt ca-bundle.pem\n```\nValidate certificate expiration dates to ensure the certificate is not expired:\n\n```\nopenssl x509 -in leaf.crt -noout -dates\n```\n\nSample Output:\n\n```\nnotBefore=Jul 31 12:28:08 2025 GMT\nnotAfter=Oct 29 12:28:08 2025 GMT\n```\n\n\n\nPerform certificate chain verification to ensure the trust path is valid:\n\n```\nopenssl verify -CAfile ca-bundle.pem leaf.crt\n```\n\nSample Output:\n\n```\nleaf.crt: OK\n```\n\n\n\nStep 5: Certificate Content Validation\n\nValidate certificate contents including Subject Alternative Names (SANs) and verify that the private key matches the certificate.\n\nExtract the private key from the Secret:\n\n```\nkubectl --namespace chkk-test-cert-manager \\\n  get secret selfsigned-cert-tls -o jsonpath=\'{.data.tls\\.key}\' | base64 -d > leaf.key\n```\nList SANs on the certificate:\n\nInspect Subject Alternative Names to ensure correct DNS names are present:\n\n```\nopenssl x509 -in leaf.crt -noout -ext subjectAltName\n```\n\nSample Output:\n\n```\nX509v3 Subject Alternative Name: critical\n    DNS:example.com\n```\n\n\n\nVerify cryptographic pairing between private key and certificate by comparing modulus hashes:\n\n```\necho "Certificate modulus hash:"\nopenssl x509 -in leaf.crt -noout -modulus | openssl sha256\necho "Private key modulus hash:"\nopenssl rsa -in leaf.key -noout -modulus | openssl sha256\n```\n\nSample Output:\n\n```\nCertificate modulus hash:\nSHA2-256(stdin)= 110030f83fb5ceecc0db57f878d6a41bad338dd4977e0b188208476d8e5b89d3\nPrivate key modulus hash:\nSHA2-256(stdin)= 110030f83fb5ceecc0db57f878d6a41bad338dd4977e0b188208476d8e5b89d3\n```\n\n\n\nValidate Result: If the two hashes differ, the key and certificate do not belong to the same key pair — indicating a critical misconfiguration.\n\n_Note: In above test scenario, the hashes should always match since cert-manager generated both components. This check is more valuable when troubleshooting imported certificates or production issues._\n\nStep 6: Certificate Renewal Testing\n\nTest the certificate renewal functionality to ensure cert-manager can successfully handle certificate lifecycle management.\n\nManually trigger certificate renewal to test renewal controller functionality:\n\n```\ncmctl renew selfsigned-cert --namespace chkk-test-cert-manager\n```\n\nSample Output:\n\n```\nManually triggered issuance of Certificate chkk-test-cert-manager/selfsigned-cert\n```\n\n\n\nVerify the certificate remains in Ready state after renewal and check renewal events:\n\n```\ncmctl --namespace chkk-test-cert-manager status certificate selfsigned-cert\n```\n\nSample Output:\n\n```\nName: selfsigned-cert\nNamespace: chkk-test-cert-manager\nCreated at: 2025-07-31T17:28:07+05:00\nConditions:\n  Ready: True, Reason: Ready, Message: Certificate is up to date and has not expired\nDNS Names:\n- example.com\nEvents:\n  Type    Reason     Age               From                                       Message\n  ----    ------     ----              ----                                       -------\n  Normal  Issuing    10m               cert-manager-certificates-trigger          Issuing certificate as Secret does not exist\n  Normal  Generated  10m               cert-manager-certificates-key-manager      Stored new private key in temporary Secret resource "selfsigned-cert-5v8hx"\n  Normal  Requested  10m               cert-manager-certificates-request-manager  Created new CertificateRequest resource "selfsigned-cert-1"\n  Normal  Issuing    9s (x2 over 10m)  cert-manager-certificates-issuing          The certificate has been successfully issued\n  Normal  Generated  9s                cert-manager-certificates-key-manager      Stored new private key in temporary Secret resource "selfsigned-cert-xjvw8"\n  Normal  Requested  9s                cert-manager-certificates-request-manager  Created new CertificateRequest resource "selfsigned-cert-2"\nIssuer:\n  Name: test-selfsigned\n  Kind: Issuer\n  Conditions:\n    Ready: True, Reason: IsReady, Message:\n  Events:  <none>\nSecret:\n  Name: selfsigned-cert-tls\n  Issuer Country:\n  Issuer Organisation:\n  Issuer Common Name:\n  Key Usage: Digital Signature, Key Encipherment\n  Extended Key Usages:\n  Public Key Algorithm: RSA\n  Signature Algorithm: SHA256-RSA\n  Subject Key ID:\n  Authority Key ID:\n  Serial Number: 66a8aad292536674bae87df0b0738d3f\n  Events:  <none>\nNot Before: 2025-07-31T17:38:32+05:00\nNot After: 2025-10-29T17:38:32+05:00\nRenewal Time: 2025-09-29T17:38:32+05:00\n```\n\n\n\nConfirm that new CertificateRequest resources were created during the renewal process:\n\n```\nkubectl --namespace chkk-test-cert-manager get certificaterequests\n```\nSample Output (before renewal):\n\n```\nNAME                APPROVED   DENIED   READY   ISSUER            REQUESTER                                         AGE\nselfsigned-cert-1   True                True    test-selfsigned   system:serviceaccount:cert-manager:cert-manager   2m12s\n```\nSample Output (after renewal):\n\n```\nNAME                APPROVED   DENIED   READY   ISSUER            REQUESTER                                         AGE\nselfsigned-cert-2   True                True    test-selfsigned   system:serviceaccount:cert-manager:cert-manager   3m20s\n```\nStep 7: Cleanup Test Resources\n\nRemove all test resources and temporary files created during the verification process.\n\nRemove the test namespace and all associated resources:\n\n```\nkubectl delete namespace chkk-test-cert-manager\n```\nRemove temporary certificate files from the local filesystem:\n\n```\nrm -f leaf.crt leaf.key ca-bundle.pem\n```\n\n',
            type: 'text',
          },
        ],
        created: 0,
        updated: 0,
      },
    ],
    updated: 0,
  },
];
